import l1 from '../assets/img/therapy/l_1.png'
import l2 from '../assets/img/therapy/l_2.png'
import l3 from '../assets/img/therapy/l_3.png'
import l4 from '../assets/img/therapy/l_4.png'
import l11 from '../assets/img/therapy/l_1_1.png'
import h from '../assets/img/genetic/h.png'
import m from '../assets/img/genetic/m.png'
import g from '../assets/img/genetic/g.png'
import pv from '../assets/img/genetic/pv.png'
import h1 from '../assets/img/genetic/h1.jpg'
import m1 from '../assets/img/genetic/m1.png'
import g1 from '../assets/img/genetic/g1.png'
import pv1 from '../assets/img/genetic/pv1.png'
import cellbankblood from '../assets/img/service/cellbankblood.jpg'
import cellbankcomlete from '../assets/img/service/cellbankcomplete.jpg'
import cellbankgenetic from '../assets/img/service/cellbankgenetic.jpg'
import cellbanknipt from '../assets/img/service/cellbanknipt.jpg'
import cellbankTissue from '../assets/img/service/cellbankTissue.jpg'
import cellbanktooth from '../assets/img/service/cellbanktooth.jpg'
import skincell from '../assets/img/service/skincell.jpg'
import haircell from '../assets/img/service/haircell.jpg'
import spraycell from '../assets/img/service/spraycell.jpg'
const faqArray = [
  {
    id: 1,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question:
      'Хүүхдийнхээ хүйн цус, хүйн эдийн үүдэл эсийг яагаад хадгалуулах хэрэгтэй вэ?',
    answer: {
      main: '	Ирээдүйн эрүүл мэндийг хамгаалах:',
      list: [
        '• Үүдэл эсүүд нь эмчлэх боломжгүй олон өвчнийг эмчлэх ирээдүйн эмчилгээнд ашиглагдана.',
        '•	Гэр бүлийн өмч: Хадгалуулсан үүдэл эсүүд тухайн хүүхдээс гадна гэр бүлийн гишүүдэд тохирох магадлал өндөр.',
        '•	Залуу, идэвхтэй: Насанд хүрсэн хүний үүдэл эсүүд нь цөөн тоотой, хөгширсөн, өөрийгөө олшруулах, нөхөн сэргээх чадвар муудсан байдаг бол дөнгөж төрсөн хүүхдийн бие махбодод агуулагдах үүдэл эсүүдийн тоо олон тэрбум байдаг ба нөхөн сэргээх өндөртэй, залуу байдаг. Мөн насанд хүрсэн хүнээс үүдэл эсийг цуглуулахад өвдөлт, зовуурь ихтэй ажилбар шаардлагатай.'
      ]
    }
  },
  {
    id: 2,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хүйн цус, хүйн эдийн үүдэл эсийн банк гэж юу вэ?',
    answer: {
      main: 'Хүйн цус, хүйн эдийн үүдэл эсийн банк гэдэг нь шинээр төрсөн хүүхдийн хүйн цус, хүйн эдийг зориулалтын лабораторид боловсруулан гарган авсан цусны болон мезенхимийн үүдэл эсийг ирээдүйд ашиглах зорилгоор хөлдөөн хадгалдаг эрүүл мэндийн байгууллага юм. Дэлхий дахинд үүдэл эсийг хадгалдаг Public болон Family гэсэн 2 төрлийн банк байдаг.'
    }
  },
  {
    id: 3,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Public үүдэл эсийн банк гэж юу вэ?',
    answer: {
      main: 'Public буюу Нийтийн үүдэл эсийн банк нь ихэвчлэн улсын санхүүжилттэй хүйн цус, хүйн эдийн банк байдаг бөгөөд олон нийтийн хандивласан үүдэл эсийг өөр хэн нэгний эмчилгээнд зориулан хадгалдаг. Эдгээр банкнууд хүйн цус, хүйн эдийн үүдэл эс хадгалах үйлчилгээний төлбөр авдаггүй бөгөөд таны хандивласан хүйн үүдэл эсийг тухайн банк захиран зарцуулах эрхтэй байдаг.'
    }
  },
  {
    id: 4,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Family үүдэл эсийн банк гэж юу вэ?',
    answer: {
      main: 'Гэр бүлийн хүйн цус, хүйн эдийн үүдэл эсийн банк нь үүдэл эсийг зөвхөн хадгалуулагчид өөрт нь болон гэр бүлийнхэнд нь зориулан хадгалдаг. Гэр бүлийн банкнууд нь хүйн цус, хүйн эдийн үүдэл эсийн эс боловсруулалт болон хадгалалтын үйлчилгээний төлбөрийг авдаг бөгөөд хадгалуулсан хүйн цус, хүйн эдийн үүдэл эс нь хадгалуулагчийн өмч юм.'
    }
  },
  {
    id: 5,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хүйн цус, хүйн эдийн үүдэл эсийг хэзээ авч хадгалдаг вэ?',
    answer: {
      main: 'Хүүхэд төрж, ихэс салсны дараах 10 минут нь хүйн цус, хүйн эдийн үүдэл эсийг цуглуулах алтан агшин юм.'
    }
  },
  {
    id: 6,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хүйн цус, хүйн эдийг хэн цуглуулдаг вэ?',
    answer: {
      main: 'Хүйн цус, хүйн эдийг үүдэл эсийн банкны мэргэжилтэн, тухайн төрөх эмнэлгийн эх барих эмэгтэйчүүдийн эмч, эх баригч, сувилагч цуглуулна.'
    }
  },
  {
    id: 7,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хүйн цус, хүйн эдийн үүдэл эсийг хэрхэн хадгалдаг вэ?',
    answer: {
      main: 'Хүйн цус, хүйн эдийг зориулалтын лабораторид боловсруулан, цусны болон мезенхимийн үүдэл эсийг ялган, -196°С хэм бүхий шингэн азотод хадгалдаг.'
    }
  },
  {
    id: 8,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хадгалсан үүдэл эсийг хэн хэрэглэж болох вэ?',
    answer: {
      main: 'Хүүхдийн өөрийн хүйн цус болон хүйн эдийн үүдэл эс нь тухайн хүүхдэд төгс тохирч, донор хайх шаардлагагүйгээр шууд ашиглах боломжтой. Хүүхдийн үүдэл эс нь эцэг эх, эмээ өвөө, ах эгч нартайгаа тохирох магадлал өндөртэй байдаг. Өөрөөр хэлбэл хадгалуулсан хүйн цус болон хүйн эдийн үүдэл эсээс гэр бүлийн бусад гишүүд эмчилгээний үр ашиг хүртэх боломжтой гэсэн үг юм.'
    }
  },
  {
    id: 9,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хүйн цус, хүйн эдийн үүдэл эсийг хэр удаан хадгалдаг вэ?',
    answer: {
      main: 'Хөлдөөн хадгалалтын зөв нөхцөлд үүдэл эсийг онолын хувьд хязгааргүй хугацаагаар хадгалах боломжтой. Практикт анхны үүдэл эсийн банк 1992 онд үүссэн бөгөөд өнөөг хүртэл 30+ жил хадгалсаар байна. Энэ нь хүйн эсийг шаардлагатай үед, хэдэн арван жилийн дараа ч ашиглах боломжтой гэсэн үг юм.'
    }
  },
  {
    id: 10,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Аутологи шилжүүлэн суулгалт гэж юу вэ?',
    answer: {
      main: 'Аутологи шилжүүлэн суулгалт гэдэг нь өөрийн эс, эдийг тухайн хүнд өөрт нь буцаан суулгаж ашиглахыг хэлнэ. Энэ үед суулгац тохирохгүй байх асуудал үүсдэггүй. Учир нь өөрийн эд, эс нь өөрийн биедээ 100% таардаг.'
    }
  },
  {
    id: 11,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Аллоген шилжүүлэн суулгалт гэж юу вэ?',
    answer: {
      main: 'Аллоген буюу бусдын эс, эдийн шилжүүлэн суулгалт нь өөр хүний эс,эдийг шилжүүлэн суулган өвчнийг эмчлэхийг хэлнэ. Аллоген шилжүүлэн суулгалтаар цусны хавдар, дархлаа тогтолцооны төрөлхийн дутмагшлыг эмчилдэг. Донор нь тухайн хүүхдийн ах дүү, ойрын хамаатан байх тусмаа суулгац тохирох магадлал ихэсдэг.'
    }
  },
  {
    id: 12,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Суулгацын тохироо гэж юу вэ?',
    answer: {
      main: 'Донорын эс, эдийг ашиглан эмчилгээ хийх тохиолдолд шилжүүлэн суулгах гэж буй донор эс, эд нь эзэн биетэйгээ тохирох эсэхийг шинжлэх шаардлага үүсдэг ба эдийн тохирооны их бүрдэл нь молекулуудаар нийцэж буй эсэхийг үнэлдэг. Эдийн тохироо нийцээгүй тохиолдолд суулгасан донор эс, эд эзэн биеийн эсрэг довтлон суулгац эзний эсрэг урвал өрнөх эсвэл суулгац ховхрох эрсдэлийг дагуулдаг.'
    }
  },
  {
    id: 13,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хүйн цус, хүйн эдийн үүдэл эс гэж юу вэ? ',
    answer: {
      main: 'Хүйн цус, хүйн эдийн үүдэл эсүүд гэдэг нь хүүхэд төрөх үед ихсийн бүрдэл болох хүйн судсанд байх цус болон судасны эргэн тойрон дахь эдэд агуулагдах үүдэл эсүүдийг хэлнэ. Хүйн цусанд цусны үүдэл эс, хүйн эдэд мезенхимийн үүдэл эс байдаг.'
    }
  },
  {
    id: 14,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хүйн цус, хүйн эдийг цуглуулахад эх болон нярайд эрсдэл бий юу?',
    answer: {
      main: 'Үгүй. Цуглуулах үйл явц нь аюулгүй, өвдөлтгүй бөгөөд төрсний дараа хүйг тасалснаас хойш хийгддэг тул эх болон хүүхдэд ямар нэгэн эрсдэл учруулдаггүй.'
    }
  },
  {
    id: 15,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хүйн цус, хүйн эдийг цуглуулахад ямар асуудал тулгарч болох вэ?',
    answer: {
      main: 'Зарим тохиолдолд хангалттай хэмжээний хүйн цус, хүйн эд цуглуулж чадахгүй байх тохиолдол гардаг. Энэ нь хүүхэд дутуу төрсөн, ихэс хожимдож гарсан тохиолдолд эсвэл тодорхой шалтгаангүйгээр энэ эрсдэл үүсэж болно. Мөн төрөх үед яаралтай тусламж шаардлагатай бол эх болон хүүхдийн эрүүл мэндэд анхаарах нь нэгдүгээрт тавигддаг.'
    }
  },
  {
    id: 16,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question:
      'Хүйн цус болон хүйн эдийн үүдэл эсүүдийг хамт хадгалуулах нь ямар ашигтай вэ?',
    answer: {
      main: 'Хүйн цус болон хүйн эд нь өөр өөр нөхөн төлжүүлэх чадвартай, өөр төрлийн үүдэл эсүүдийг агуулдаг. Хүйн цус нь цус үүсгэгч үүдэл эсүүдийг агуулж, цус, дархлааны тогтолцооны өвчнийг эмчлэхэд ашиглагддаг бол хүйн эдийн мезенхимийн үүдэл эс нь эд, эрхтний нөхөн төлжилт, үрэвслийн эсрэг эмчилгээнд чухал үүрэг гүйцэтгэдэг. Эдгээрийг хамтад нь хадгалснаар олон төрлийн өвчин, гэмтлийг эмчлэх боломж нэмэгдэж, ирээдүйд гарах шинэ эмчилгээний аргуудыг ашиглах боломжийг өргөжүүлнэ.'
    }
  },
  {
    id: 17,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question:
      'Хүүхэд өөрийн хадгалуулсан хүйн цус болон эдийг ашиглах магадлал хэр вэ?',
    answer: {
      main: 'Хүүхэд өөрийн хадгалуулсан хүйн цус эсвэл хүйн эдийн үүдэл эсийг ашиглах магадлал нь тухайн хүүхдийн амьдралын туршид эсийн эмчилгээгээр эмчлэх боломжтой өвчин үүсэх магадлалтай тэнцүү юм. Чихрийн шижин, зүрхний шигдээс, артрит, паркинсоны өвчин, саажилт болон цус харвалт зэрэг өвчнүүд нь эсийн эмчилгээний голлох зорилтот өвчнүүд бөгөөд хүн амьдралынхаа туршид эдгээр өвчнүүдийн аль нэгтэй тулгарах магадлалтай байдаг.'
    }
  },
  {
    id: 18,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question:
      'Хүүхэд өөрийн хадгалуулсан хүйн цусны үүдэл эсийг хэдэн удаа ашиглаж болох вэ?',
    answer: {
      main: 'Одоогоор хүйн цусны үүдэл эсээр эмчилж буй өвчнүүдийн ихэнх нь амь насанд аюултай өвчнүүд байдаг тул шилжүүлэн суулгалт хийж буй эмч нь эмчилгээний амжилтыг нэмэгдүүлэхийн тулд боломжтой бүх үүдэл эсийг ашигладаг. Гэсэн хэдий ч ирээдүйд үүдэл эсийг 100 болон түүнээс олон дахин хүртэл "өсгөвөрлөх" аргууд судлагдаж байгаа учраас энэ байдал өөрчлөгдөх магадлалтай. Үүний үр дүнд хүйн цусны үүдэл эс нь олон тунгаар, олон удаа ашиглах боломжтой бүтээгдэхүүн болох магадлалтай.'
    }
  },
  {
    id: 19,
    tag: 'Эсийн банк',
    category: 'Ерөнхий ойлголт',
    question: 'Хүйн цус болон хүйн эдийн хадгалалтад хэн оролцох вэ?',
    answer: {
      main: 'Селл Клиник эмнэлгийн хамт олон.'
    }
  },

  // Хүйн цус
  {
    id: 20,
    tag: 'Эсийн банк',
    category: 'Хүйн цус',
    question: 'Хүйн цус гэж юу вэ?',
    answer: {
      main: 'Хүйн цус нь төрсний дараа хүйн судсанд үлдсэн илүүдэл ургийн цус юм. Уламжлал ёсоор хүүхэд төрсний дараа хаягддаг байсан хүйн цусыг одоо цусны үүдэл эсийн (HSCs) үнэт эх үүсвэр гэж хүлээн зөвшөөрдөг болсон.'
    }
  },
  {
    id: 21,
    tag: 'Эсийн банк',
    category: 'Хүйн цус',
    question: 'Хүйн цусанд ямар үүдэл эсүүд агуулагддаг вэ?',
    answer: {
      main: 'Хүйн цусанд цусны үүдэл эс, эндотелийн урьдал эс, маш жижиг хөврөлийн үүдэл эс төст эс, Т зохицуулагч эс, байгалийн устгагч эс, моноцит болон сэртэнт эс зэрэг олон  төрлийн эсүүд агуулагддаг. Хүйн цусны үүдэл эсийг цусны үүдэл эс гэж нэрлэнэ.'
    }
  },
  {
    id: 22,
    tag: 'Эсийн банк',
    category: 'Хүйн цус',
    question: 'Цусны үүдэл эс гэж юу вэ?',
    answer: {
      main: 'Цусны үүдэл эс (гематопоэтик эс) нь цусны бүх төрлийн эсийг үүсгэх чадвартай эх эс юм. Эдгээр эсүүд нь ясны чөмөг, цус, хүйн цусанд агуулагддаг. Тэд цусны улаан эс, цагаан эс, тромбоцит зэрэг эсийг үүсгэж, цус болон дархлаа тогтолцоог бий болгодог.'
    }
  },
  {
    id: 23,
    tag: 'Эсийн банк',
    category: 'Хүйн цус',
    question: 'Цусны үүдэл эсийг эмчилгээнд хэрхэн хэрэглэх вэ?',
    answer: {
      main: 'Цусны үүдэл эсийг дархлаа тогтолцооны өвчин, удамшлын эмгэг, мэдрэлийн эмгэг, цусны хорт хавдрыг оролцуулаад 70 гаруй төрлийн өвчнийг эмчлэхэд ашигладаг. Мөн зарим улс орнуудад тархины саажилт, чонон хөрвөс, зүрхний шигдээс, чихрийн шижинг эмчлэхэд ашиглаж байна.'
    }
  },
  {
    id: 24,
    tag: 'Эсийн банк',
    category: 'Хүйн цус',
    question:
      'Хүйн цусны үүдэл эсийг ясны чөмгөний үүдэл эсээс илүү эмчилгээнд ашиглах давуу талууд юу вэ?',
    answer: {
      main: 'хадгалан:',
      list: [
        '• Цусны үүдэл эсийг хөлдөөж хадгалаад шаардлагатай үед дахин ашиглах боломжтой байдаг бол ясны чөмгөний үүдэл эсийг шууд ашиглах шаардлагатай байдаг.',
        '•	Цуглуулахад хялбар: Чөмгөнөөс цусны үүдэл эсийг цуглуулахад донорт зовуурь ихтэй, эрсдэлтэй байдаг бол хүйн цуснаас үүдэл эс цуглуулах нь илүү аюулгүй, хялбар байдаг.',
        '•	Аллоген шилжүүлэн суулгалтад тохирох магадлал өндөр: Цусны үүдэл эс нь дархлаа тогтолцоог үүсгэгч эсүүд учир шилжүүлэн суулгах тохиолдолд эзэнтэйгээ тохирсон байхыг шаарддаг. Шилжүүлэн суулгах үед цусны үүдэл эс нь ясны чөмгөний үүдэл эстэй харьцуулахад тохирох боломж өндөртэй.'
      ]
    }
  },
  //   хүйн эд

  {
    id: 25,
    tag: 'Эсийн банк',
    category: 'Хүйн эд',
    question: 'Хүйн эд гэж юу вэ?',
    answer: {
      main: 'Хүйн эд нь нярайн хүйн судасны эргэн тойронд байрлах зөөлөн эд бөгөөд “Wharton Jelly” гэж нэрлэгддэг бүтэц юм. Энэ эд нь мезенхимийн үүдэл эсээр (MSC) баялаг эх үүсвэр болж өгдөг.'
    }
  },
  {
    id: 26,
    tag: 'Эсийн банк',
    category: 'Хүйн эд',
    question: 'Хүйн эдэд ямар үүдэл эсүүд агуулагддаг вэ?',
    answer: {
      main: 'Хүйн эдэд мезенхимийн үүдэл эс (MSC) их хэмжээтэй, судасны үүдэл эс бага хэмжээтэй агуулагддаг. Мезенхимийн үүдэл эс нь хүйн цусны үүдэл эстэй харьцуулахад илүү олон төрлийн эс болон хувирах чадвартай бөгөөд нөхөн төлжүүлэх анагаах ухаанд өргөн хүрээнд ашиглагддаг. Хүйн эдийн үүдэл эсийг мезенхимийн үүдэл эс гэж нэрлэнэ.'
    }
  },
  {
    id: 27,
    tag: 'Эсийн банк',
    category: 'Хүйн эд',
    question: 'Мезенхимийн үүдэл эс (MSCs) гэж юу вэ?',
    answer: {
      main: 'Мезенхимийн үүдэл эс нь Олон төрлийн эс болон хувирах чадвартай. Үүнд: ',
      list: [
        ' •	Ясны эсүүд (остеоцит), Мөгөөрсний эсүүд (хондроцит), Өөхний эсүүд (адипоцит), Булчингийн эсүүд (миоцит), Мэдрэлийн эсүүд (нейрон).',
        '•	Дархлаа тогтолцоонд нөлөөлөх: Үрэвслийг бууруулж, шаардлагагүй дархлааны хариу урвалаас сэргийлдэг.',
        '•	Эд нөхөн төлжүүлэх: Эд, эсийг нөхөн төлжүүлэх: Шархыг эдгээж, гэмтсэн эд, эсийг нөхөн сэргээхэд тусалдаг.',
        '•	Хөгшрөлтийн эсрэг: Арьсны үрчлээг багасгах, гоо сайхны эмчилгээнд үр дүнтэй.',
        '•	Өөрийгөө хувилах: Мезенхимийн үүдэл эс нь хувилан олшрох онцгой чадвартай.'
      ]
    }
  },
  {
    id: 28,
    tag: 'Эсийн банк',
    category: 'Хүйн эд',
    question:
      'Хүйн эдээс гаргаж авсан мезенхимийн үүдэл эсүүд яагаад онцгой вэ?',
    answer: {
      main: 'Хүйн эдийн мезенхимийн үүдэл эс нь насанд хүрэгчдийн өөхний гаралтай мезенхимийн үүдэл эсээс (ADMSCs) олшрох болон нөхөн сэргээх чадвараараа 10-100 дахин илүү байдаг гэж судалгаанууд харуулдаг. Мөн насанд хүрэгчдийн хөгширсөн үүдэл эстэй харьцуулахад генийн мутаци үүссэн байх магадлал багатай.'
    }
  },
  {
    id: 29,
    tag: 'Эсийн банк',
    category: 'Хүйн эд',
    question: 'Мезенхимийн үүдэл эсийг эмчилгээнд хэрхэн хэрэглэх вэ?',
    answer: {
      main: 'Эд нөхөн төлжүүлэх:',
      list: [
        '•	Мөгөөрс, яс, булчинг нөхөн төлжүүлэх, үе мөчний үрэвсэл зэрэг эмгэгийг эмчлэх, шарх эдгээх, арьс нөхөн төлжүүлэх.',
        '•	Дархлааны эмгэгүүд: Үе мөчний үрэвсэл, чонон хөрвөс, склероз зэрэг өвчнийг дархлаа тогтолцоог зохицуулах замаар эмчлэх.',
        '•	Мэдрэлийн эмгэгүүд: Паркинсоны өвчин, Альцгеймер, нугасны гэмтэл, цус харвалт зэргийг эмчлэх боломжит эмчилгээ.',
        '•	Зүрх судасны эмчилгээ: Зүрхний шигдээсний дараах зүрхний булчингийн эдийг нөхөн төлжүүлэх,  захын артерийн эмгэгийг эмчлэх.',
        '•	Чихрийн шижин ба бодисын солилцооны эмгэгүүд: Инсулин ялгаруулдаг эсүүдийг төлжүүлэхэд дэмжлэг үзүүлэх.',
        '•	Үрэвсэл бууруулах эмчилгээ: Crohn’s өвчин болон суулгац эзний эсрэг урвал (GVHD) зэрэг архаг өвчний үрэвслийг бууруулах.',
        '•	Гоо сайхан ба нөхөн төлжүүлэх анагаах ухаан: Арьсны өнгийг сэргээх, сорви багасгах нөхөн сэргээх хэрэглээ.',
        '•	Нөхөн сэргээх чадавх: Гэмтсэн эдийг нөхөн төлжүүлж, үр дүнтэй эмчилгээ үзүүлэх боломжтой.',
        '•	Хавдрын эмчилгээ: Хорт хавдрын эмчилгээнд хэрэглэх боломжтой.'
      ]
    }
  },
  //   Эсийн эмчилгээ
  {
    id: 30,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell гэж юу вэ?',
    answer: {
      main: 'SprayCell нь таны өөрийн эрүүл арьснаас гаргаж авсан олон төрлийн амьд эсийн холимог бөгөөд кератиноцит, фибробласт, меланоцит зэрэг эсүүдийг агуулдаг. Эдгээр эсүүд нь шархны эдгэрэлтийг хурдасгаж, нөсөөжилтийг багасгахад тусалдаг. Энэ эмчилгээний технологи нь түлэгдэлтийн үед  шилжүүлэн суулгах эрүүл арьсны хэмжээг эрс багасгах боломжийг олгодог.'
    }
  },
  {
    id: 31,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell - ийг ямар үед хэрэглэх вэ?',
    answer: {
      main: 'Түлэнхийн эмчилгээ:',
      list: [
        '•	SprayCell нь түлэнхийн шарх эдгэрэлтийг түргэсгэж, арьсыг шинэ, эрүүл эсүүдээр ханган, нөхөн төлжих үйл явцыг хурдасгадаг.',
        '•	Арьсны том талбайг хамарсан түлэгдлийн үед арьс нөхөх мэс заслын үр дүнг сайжруулахад нэмэлтээр ашиглах боломжтой бөгөөд сорви үүсэх эрсдэлийг багасгадаг.'
      ],
      main2: 'Шарх эдгээх:',
      list2: [
        '•	Архаг шарх, чихрийн шижингийн шарх болон мэс заслын шархыг эмчлэхэд үр дүнтэй.',
        '•	Шүршсэн эсүүд нь арьсны нөхөн төлжилтийг дэмжиж, халдварын эрсдэлийг багасгадаг.'
      ],
      main3: 'Нөсөөжилтийн эмгэг:',
      list3: [
        '•	Витилиго зэрэг пигмент алдагдлыг эмчлэхэд цацсан эсийн холимогт агуулагдах меланоцит эсүүд арьсны өнгийг сэргээн, жигдрүүлж өгдөг.'
      ]
    }
  },
  {
    id: 32,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell эмчилгээний явц?',
    answer: {
      main: 'SprayCell эсийн бүтээгдэхүүнийг гурван үндсэн алхмаар бэлтгэдэг:',
      list: [
        '1.	Цуглуулах: Өвчтөний эрүүл арьсны жижиг хэсгийг (1/80см2) дерматом багажаар донор болгон авах. ',
        '2.	Боловсруулах: GMP лабораторид арьсны эдийг задлан, эсүүдийг ялгана.',
        '3.	Цацах: Арьсны эсийн холимгийг шарханд цацаж, арьсны өнгөн давхаргыг нөхөн төлжүүлнэ.'
      ]
    }
  },
  {
    id: 33,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell – ийн эдгэрлийн механизм юу вэ?',
    answer: {
      main: 'Шарх өөрөө эдгэрэх явцад эрүүл арьсны зах ирмэгээс эдгэрлийн голомт үүсэж, шархны голын хэсэг буюу дотогш чиглэн явагддаг тул хумиралдан, сорви үүсэх магадлалыг нэмэгдүүлж байдаг. Энэ үед SprayCell-ийг эмчилгээнд ашигласнаар маш олон хэсгүүдэд жижиг хэмжээний эдгэрлийн голомт үүсгэн, голомтоос тал тал тийшээ тархах байдлаар нөхөн төлжилт явагддаг учраас сорви үүсэлт бага байгаад зогсохгүй хурдан эдгэдэг онцлогтой.'
    }
  },
  {
    id: 34,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question:
      'SpayCell эмчилгээнд ямар төрлийн эсүүд чухал үүрэг гүйцэтгэдэг вэ?',
    answer: {
      list: [
        '• Фибробластууд',
        '• Кератиноцитууд',
        '• Меланоцитууд',
        '• Арьсны үүдэл эсүүд (ESCs)'
      ]
    }
  },
  {
    id: 35,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell арьсны эдгэрэлтийг хэрхэн дэмждэг вэ?',
    answer: {
      main: 'SprayCell нь эсийн түвшинд эдгэрэлтийг хурдасгадаг. Кератиноцитууд нь "чөлөөт ирмэгийн" дохиог дамжилтыг идэвхжүүлж, эсүүдийн түргэн шилжилт, арьсны өнгөн давхарга дахин бүрэлдэх үйл явцыг өдөөдөг. Мөн фибробластууд нь коллаген, эластин, эсийн гаднах матрицын уургуудыг ялгаруулж шинээр үүсэж буй арьсны сорвижилтыг бууруулдаг.  Меланоцитууд меланин үүсгэснээр арьсны байгалийн өнгийг сэргээдэг.'
    }
  },
  {
    id: 36,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell арьс нөхөх мэс засал эмчилгээг орлож чадах уу?',
    answer: {
      list: [
        'Хэт гүн буюу арьсны бүх давхаргыг хамарсан түлэгдэлтээс бусад хөнгөн түлэгдэлтийн үед арьс шилжүүлэн суулгасантай ижил үр дүнг үзүүлдэг. Их талбайг хамарсан түлэгдэлтийн үед шилжүүлэн суулгах арьсны хүрэлцээгүй асуудлын шийдэл болдог.',
        'Мөн SprayCell эсийн холимгийг арьс нөхөх мэс заслын эмчилгээтэй хавсран хэрэглэснээр эдгэрлийг сайжруулах, хурдасгах, сорви үүсэлтийг багасгах үр дүнг үзүүлдэг.'
      ]
    }
  },
  {
    id: 37,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell донор арьсны хэмжээг багасгадаг уу?',
    answer: {
      main: 'SprayCell эмчилгээ нь уламжлалт арьс шилжүүлэн суулгах мэс засалтай харьцуулахад шилжүүлэн суулгах арьсны хэмжээг 60-80 дахин багасгадаг. Өөрөөр хэлбэл 1 см² донор арьс 80 см² шарх эмчлэх арьсны эсийн холимгийг бэлтгэхэд хангалттай.'
    }
  },
  {
    id: 38,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell -ийг өөр ямар эмчилгээтэй хавсарч хэрэглэдэг вэ?',
    answer: {
      main: 'Хэсэг газрын гүн түлэгдэлтэд арьсны mesh- эмчилгээтэй хавсран хэрэглэх, бусад төрлийн шарх, мэс заслын дараах арьс нөхөлт.'
    }
  },
  {
    id: 39,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell-ийг архаг шарханд ашиглаж болох уу?',
    answer: {
      main: 'SprayCell нь эдгэрэхэд хэцүү нарийн төвөгтэй шархыг эмчлэхэд ашиглагдаж болдог.'
    }
  },
  {
    id: 40,
    tag: 'Эсийн эмчилгээ',
    category: 'SprayCell',
    question: 'SprayCell нөхөн сэргээх гоо сайхны мэс засалд ашиглагдах уу?',
    answer: {
      main: 'SprayCell-ийг нөхөн сэргээх гоо сайхны мэс заслын шарханд ашиглаж болно.'
    }
  },
  //   SkinCell
  {
    id: 41,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'SkinCell гэж юу вэ?',
    answer: {
      main: 'SkinCell нь таны өөрийн эрүүл арьснаас жижиг хэмжээний арьсны эд авч, түүнийг арьсны эсийн холимог болгон боловсруулж, нүүр болон бусад хэсэгт буцаан тарьж, арьсны нөхөн төлжилт, хөгшрөлтийн эсрэг дэвшилтэт аутологи эмчилгээ юм.'
    }
  },
  {
    id: 42,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'SkinCell эмчилгээг хэн хийлгэж болох вэ?',
    answer: {
      list: [
        '•	Арьсны хөгшрөлтийн шинж тэмдэгтэй хүмүүс: Гоо сайхандаа анхаарал тавьдаг бүх хүмүүс болон гүн үрчлээ, нарийн үрчлээ, арьсны уян хатан чанар алдагдсан хүмүүст.',
        '•	Батганы сорви болон бусад сорвитой хүмүүс: Арьсны гадаргууг жигдрүүлэх хүсэлтэй хүмүүст.'
      ]
    }
  },
  {
    id: 43,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'SkinCell-ээр ямар эмчилгээ хийх вэ?',
    answer: {
      list: [
        'Энэхүү эмчилгээ нь үрчлээг багасгах, арьсыг залуужуулах, мэс заслын сорви, батганы сорвийг эмчлэхэд зориулагдсан.',
        'o	Гоо сайхны залуужуулах үйлчилгээ: Арьсны бүтэц, өнгө, уян хатан чанарыг сайжруулж, коллаген болон эластин үйлдвэрлэлийг идэвхжүүлдэг. Үрчлээ, сорви, хөгшрөлтийн шинж тэмдгүүдийг багасгадаг.',
        'o	Пигментацийн эмгэг: Витилиго болон гипопигментацийг эрүүл арьсны хэсгийн меланоцит эсийг шилжүүлэн  суулгах замаар өнгийг сэргээн эмчилдэг.',
        'o	Шарх эдгээх: Түлэнхий, архаг шарх, арьсны гэмтлийг эмчлэхэд үр дүнтэй. Эпителийн нөхөн төлжилтийг хурдасгаж, сорви үүсэхийг багасгадаг.'
      ]
    }
  },
  {
    id: 44,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'SkinCell эмчилгээний онцлог юу вэ?',
    answer: {
      main: 'Аутологи буюу хүний өөрийн арьсны эсүүдийг өөрт нь ашигладаг тул хор нөлөөгүй, харшил болон дархлааны хариу урвал үүсэхгүй, үр нөлөө өндөртэй нөхөн сэргээх анагаах ухааны дэвшилтэт эмчилгээ юм. Өөрөөр хэлбэл гаднын химийн болон биологийн гаралтай хадгалагдсан бүтээгдэхүүнээр бус хүний өөрийн амьд эсээр эмчлэх органик арга юм.'
    }
  },
  {
    id: 45,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'SkinCell-ээр хэрхэн эмчилдэг вэ?',
    answer: {
      main: 'SkinCell эмчилгээ нь дараах үе шатуудыг дамжин таны эмчилгээнд хэрэглэгддэг:',
      list: [
        '1.	Арьсны дээж авах: Арьснаас жижиг хэмжээний биопси буюу дээж авна.',
        '2.	Эсийн холимог бэлтгэх: Авсан эдийг GMP лабораторид боловсруулж, арьсны эсүүдийг ялган, эсийн холимгийг бэлтгэнэ.',
        '3.	Тарилга: Бэлтгэсэн эсийн холимгийг нүүр болон бусад шаардлагатай хэсэгт тарьж, арьсны нөхөн төлжилтийг дэмжинэ.'
      ]
    }
  },
  {
    id: 46,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'Эмчилгээнд ашиглагдах эсийн төрөл ба үйл ажиллагааны механизм?',
    answer: {
      main: '  SkinCell эмчилгээнд дараах төрлийн эсүүд чухал үүрэг гүйцэтгэдэг:',
      list: [
        'o	Фибробластууд: Коллаген, эластин зэрэг арьсны бүтцийг дэмждэг гол уургуудыг үйлдвэрлэнэ. Арьсны уян хатан чанарыг нэмэгдүүлж, үрчлээ багасгахад чухал үүрэгтэй.',
        'o	Кератиноцитууд: Арьсны гадаргууг шинэчлэх, хамгаалах давхаргыг сэргээнэ. Гэмтсэн арьсны нөхөн төлжилтийг түргэсгэнэ.',
        'o	Меланоцитууд: Арьсны байгалийн өнгийг сэргээж, пигментацийн асуудлыг багасгадаг.',
        'o	Арьсны үүдэл эсүүд (ESCs): Эсийн нөхөн төлжилтийг өдөөж, арьсны шинэ эд үүсэхэд тусалдаг. Үрэвслийг бууруулж, эдгэрэлтийг хурдасгана.'
      ]
    }
  },
  {
    id: 47,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'SkinCell эмчилгээний давуу талууд?',
    answer: {
      list: [
        '•	Байгалийн гаралтай: Хүний өөрийн эсийг ашигладаг тул харшил болон хариу урвал үүсэх эрсдэл бага.',
        '•	Энгийн болон аюулгүй: Эмчилгээ нь мэргэжлийн эмчийн хяналтад явагддаг.',
        '•	Урт хугацааны үр дүн: Арьсны нөхөн төлжилтийг дэмжиж, залуужилтын үр дүнг удаан хугацаанд хадгална.'
      ]
    }
  },
  {
    id: 48,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'SkinCell эмчилгээний үйл явц?',
    answer: {
      list: [
        '•	Эмчилгээний хугацаа: Ойролцоогоор 1-2 цаг.',
        '•	Эдгэрэлтийн хугацаа: Арьсны эд авахад үүссэн шарх (2-4мм) 3-4 хоногийн дараа бүрэн эдгэнэ. ',
        '•	Үр дүнгийн эхлэл: 2-4 долоо хоногт үр дүн илэрч эхэлнэ.'
      ]
    }
  },
  {
    id: 49,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'SkinCell эмчилгээг хийлгэхэд гаж нөлөө бий юу?',
    answer: {
      main: 'SkinCell нь аюулгүй эмчилгээ боловч дараах зовууриуд илэрч болзошгүй.',
      list: [
        '•	Түр зуурын улайлт: Тарилгын хэсэгт бага зэрэг улайж болно.',
        '•	Хавагнах: Бага зэргийн хавдалт үүсэж магадгүй.',
        '•	Зовуурь: Тарилга хийгдсэн хэсэгт түр зуурын өвдөлт мэдрэгдэж болно.',
        'Эдгээр шинж тэмдгүүд нь 2-4 өдрийн дотор арилах боломжтой.'
      ]
    }
  },
  {
    id: 50,
    tag: 'Эсийн эмчилгээ',
    category: 'SkinCell',
    question: 'SkinCell эмчилгээний дараа ямар арчилгаа хийх вэ?',
    answer: {
      list: [
        '•	Тарилга хийлгэсний дараах эхний 48 цагт тарьсан хэсэгт гоо сайхны бүтээгдэхүүн болон ус хүргэхгүй байх.',
        '•	Нарнаас хамгаалах: Нарны тос түрхэж, шууд нарны тусгалаас арьсыг хамгаалах.',
        '•	Чийгшүүлэгч хэрэглэх: Чийгшүүлэгч бүтээгдэхүүн ашиглан арьсыг чийгтэй байлгах.',
        '•	Зөөлөн арчилгаа: Хүчтэй химийн найрлагатай бүтээгдэхүүнээс зайлсхийх.'
      ]
    }
  },

  // HairCell
  {
    id: 51,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'HairCell гэж юу вэ?',
    answer: {
      main: 'HairCell нь үс уналтыг багасгаж, үсний ургалтыг дэмжих зориулалттай дэвшилтэт эсийн эмчилгээ юм. Энэ нь хуйхны хэсгээс жижиг хэмжээний дээж авч, үсний уутанцрын үүдэл эс болон бусад эсийг ялган авсан амьд эсийн холимог юм. Эдгээр эсийн холимгийг үс ургуулах шаардлагатай хэсэгт тарьж, байгалийн аргаар үс ургах нөхцөлийг бүрдүүлнэ. Тарьсан хэсэгт үсний уутанцрын үүдэл эс нь шинээр үсний уутанцрыг үүсгэж үсний ургалтыг дэмжинэ.'
    }
  },
  {
    id: 52,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'HairCell -д ямар эсүүд агуулагддаг вэ?',
    answer: {
      main: '  HairCell нь хүний өөрийн хуйхны олон төрлийн амьд эсийн нөхөн төлжүүлэх чадварыг ашигладаг.',
      list: [
        '•	Үсний уутанцрын үүдэл эсүүд (HFSCs): Эдгээр эсүүд нь үсний уутанцрын олон төрлийн эс болон хувирах чадвартай.',
        '•	Арьсны папиллын эсүүд: Үсний уутанцрын суурь хэсэгт байрладаг бөгөөд үсний ургалтын мөчлөгийг зохицуулдаг.',
        '•	Кератиноцитууд: Үсний бүтцийн уураг болох кератиныг ялгаруулдаг арьсны эсүүд.',
        '•	Меланоцитууд: Үсний байгалийн өнгийг үүсгэгч меланиныг үйлдвэрлэдэг эсүүд.',
        '•	Фибробласт: Коллаген, эластин зэрэг эсийн гаднах матриц уургийг ялгаруулж, эдийн бүтцийг тогтворжуулан, гэмтсэн эдийг нөхөн сэргээх үүрэгтэй.'
      ]
    }
  },
  {
    id: 53,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'HairCell эмчилгээг хэн хийлгэх вэ?',
    answer: {
      list: [
        '•	Андроген халзралт (эрэгтэй, эмэгтэй үс халзралт)',
        '•	Хэсэгчилсэн үс уналт буюу үс шингэрэлт',
        '•	Гэмтэл эсвэл сорвиноос үүдэлтэй үсний уналт',
        '•	Үсний уналтын эхний үе шат'
      ]
    }
  },
  {
    id: 54,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'Эмчилгээний үйл явц хэрхэн явагддаг вэ?',
    answer: {
      list: [
        '•	Жижиг хэмжээний арьсны дээж авах: Чихний арын хуйхнаас жижиг хэмжээний эд авч хуйхны эсүүдийг GMP лабораторид боловсруулна.',
        '•	Эсийн холимог бэлтгэх: Боловсруулсан эсүүдийг тарилга хийхэд тохиромжтой байдлаар бэлтгэнэ.',
        '•	Тарилга хийх: Эсийн холимгийг хуйхны шаардлагатай хэсэгт тарьж, үсний ургалтыг дэмжинэ.'
      ]
    }
  },
  {
    id: 55,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'HairCell бусад үсний эмчилгээнээс юугаараа ялгаатай вэ?',
    answer: {
      list: [
        '•	Амьд эсийн холимог: Хүний өөрийнх нь хуйхны олон төрлийн амьд эсийг өөрт нь ашигладаг тул биологийн органик эмчилгээ юм.',
        '•	Байгалийн нөхөн төлжилт: Өөрийн эсүүдийг ашигласнаар үс өөрөөрөө ургадаг.',
        '•	Өвдөлт бага: Үйл явц хурдан бөгөөд эдгэрэх хугацаа богино.',
        '•	Шууд үр дүн: Эсүүдийг шаардлагатай хэсэгт шууд тарьдаг.',
        '•	Химийн нөлөөгүй: Үс арчилгааны бүтээгдэхүүнүүдтэй харьцуулахад химийн нэгдлүүдийг ашиглахгүй.',
        '•	Урт хугацааны үр дүн: Үсний уутанцрын үйл ажиллагааг идэвхжүүлж, урт хугацаанд үсний ургалтыг дэмжинэ.'
      ]
    }
  },
  {
    id: 56,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'HairCell аюултай юу?',
    answer: {
      list: [
        '•	Өөрийн эд, эсийг ашиглах: Таны өөрийн эсийг ашигладаг тул харшил эсвэл дархлааны хариу урвал үүсэх эрсдэлгүй.',
        '•	Мэргэжлийн эмчийн хяналт: Арьснаас дээж авах, эсийг тарих үйл явц мэргэжлийн эмчийн хяналтад хийгдэнэ.',
        '•	Богино хугацааны эдгэрэлт: Эмчилгээний дараа ихэнх үйлчлүүлэгч өдөр тутмын хэвийн амьдралдаа буцаж орох боломжтой.'
      ]
    }
  },
  {
    id: 57,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'Үр дүнг хэзээнээс харж эхлэх вэ?',
    answer: {
      main: ' Үр дүн нь хувь хүний үсний уналтын байдал болон уутанцрын идэвхээс хамааран өөр өөр байдаг.',
      list: [
        '•	Эхний үр дүн: Эмчилгээ хийснээс хойш 2–3 сарын дотор мэдэгдэхүйц өөрчлөлт ажиглагдана.',
        '•	Бүрэн үр дүн: Ойролцоогоор 6–12 сарын дараа үсний уутанцрын нөхөн төлжилт бүрэн явагддаг.'
      ]
    }
  },
  {
    id: 58,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'Хэдэн удаагийн эмчилгээ шаардлагатай вэ?',
    answer: {
      main: 'Ихэнх үйлчлүүлэгчдэд 1–2 удаагийн эмчилгээ хангалттай байдаг. Эмч таны хэрэгцээнд нийцүүлэн хувийн эмчилгээний төлөвлөгөө гаргана.'
    }
  },
  {
    id: 59,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'Гаж нөлөө бий юу?',
    answer: {
      main: 'HairCell эмчилгээ нь ихэнх тохиолдолд гаж нөлөөгүй байдаг. Гэсэн хэдий ч зарим хүмүүст тариулсан хэсэгт бага зэрэг улайх эсвэл хавагнах, түр зуурын таагүй мэдрэмж төрж болох юм. Эдгээр шинж тэмдгүүд нь хэдхэн өдрийн дотор арилах боломжтой.'
    }
  },
  {
    id: 60,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'HairCell эмчилгээ тохирохгүй  байх тохиолдол байдаг уу?',
    answer: {
      main: 'HairCell дараах тохиолдлуудад тохирохгүй байх магадлалтай:',
      list: [
        '•	Хэт халзралттай: Үсний уутанцрын үйл ажиллагаа бүрэн зогссон тохиолдолд.',
        '•	Дархлааны эмгэгтэй: Үс уналттай холбоотой дархлааны өвчин (жишээ нь, аутоиммун үс уналт). Аутоиммун халзралттай хүнд энэ эмчилгээг зөвлөдөггүй. Учир нь таны биед таны үсний булцууны эсийн эсрэг бие агуулагдаж байгаа тул энэ эмчилгээг хийлгэсэн ч үс уналт зогсдоггүй. Харин ч эсрэгээрээ дархлааны хариу урвалыг өдөөж сөрөг нөлөө үзүүлнэ.',
        '•	Эдгэрэлтэд сөрөг нөлөө үзүүлэх эм эсвэл хууч өвчин байгаа бол: Манай эмнэлгийн эмчтэй хийсэн уулзалт, зөвлөгөө HairCell танд тохиромжтой эсэхийг тодорхойлох болно.'
      ]
    }
  },
  {
    id: 61,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'Ямар үр дүнг хүлээж болох вэ?',
    answer: {
      list: [
        'o	1–3 сар: Үсний уналт мэдэгдэхүйц багасна. Үсний шингэрсэн хэсэгт анхны ургалт ажиглагдана.',
        'o	3–6 сар: Үсний нягтрал болон өтгөрөл мэдэгдэхүйц нэмэгдэнэ. Үсний бат бөх чанар сайжирна.',
        'o	6–12 сар: Тарилгад хамрагдсан хэсэгт үсний ургалт илт нэмэгдэнэ. Үсний эрүүл болон тэжээллэг, бат бөх байдал урт хугацаанд хадгалагдана.',
        'Үр дүн нь нас, үс уналтын хэмжээ болон бусад хувь хүний хүчин зүйлээс шалтгаалж өөр байж болно.'
      ]
    }
  },
  {
    id: 62,
    tag: 'Эсийн эмчилгээ',
    category: 'HairCell',
    question: 'Эмчилгээний дараа ямар арчилгаа хийх вэ?',
    answer: {
      list: [
        ' •	Тарилгын дараа 24–48 цагийн турш толгой угаахгүй байх.',
        '•	Хүчтэй химийн бодис агуулаагүй зөөлөн шампунь хэрэглэх.',
        '•	Эмчилгээний үр дүнг урт хугацаанд хадгалахын тулд 4–6 сарын дараа давтан хийлгэх шаардлагатай байж болно.',
        '•	Эрүүл хооллолт, толгойн хуйх арчилгаа нь үр дүнг улам сайжруулна.'
      ]
    }
  },
  //   ERP
  {
    id: 63,
    tag: 'Эсийн эмчилгээ',
    category: 'ERP',
    question: 'ERP гэж юу вэ?',
    answer: {
      main: 'ERP (Exosome Rich Plasma) нь үйлчлүүлэгчийн захын цуснаас ялган авсан цусны ялтас эсээс ялгарах экзосомоор баялаг плазмын нөхөн сэргээх дэвшилтэт эмчилгээний арга юм. Экзосом нь эс хоорондын мэдээлэл дамжуулж, эд, эсийн нөхөн төлжилт, үрэвслийн эсрэг үйл ажиллагаанд чухал үүрэг гүйцэтгэдэг 30-150 нанометр хэмжээтэй. ERP нь арьс, үс, үе мөчинд нөхөн сэргээх, үрэвслийн эсрэг үйлдэл үзүүлдэг.'
    }
  },
  {
    id: 64,
    tag: 'Эсийн эмчилгээ',
    category: 'ERP',
    question: 'ERP ба PRP-ийн ялгаа юу вэ?',
    answer: {
      main: 'ERP (Exosome Rich Plasma) болон PRP (Platelet Rich Plasma) нь өөр өөр найрлага, үйлчлэлтэй:',
      list: [
        '•	ERP: Эсээс ялгарсан экзосомоор баялаг плазмыг ашигладаг. Экзосом нь өсөлтийн хүчин зүйлс, микрoРНХ зэрэг молекулуудыг дамжуулж, эсийн нөхөн төлжилтийг идэвхжүүлдэг.',
        '•	PRP: Ялтас эсээр баялаг плазмыг ашигладаг. Ялтас эс нь нөхөн төлжилтийг дэмждэг.',
        '•	ERP нь PRP-тай харьцуулахад 5-10 дахин илүү үр дүн үзүүлдэг дараагийн үеийн эсийн түвшний эмчилгээ юм.'
      ]
    }
  },
  {
    id: 65,
    tag: 'Эсийн эмчилгээ',
    category: 'ERP',
    question: 'ERP эмчилгээний хэрэглээ?',
    answer: {
      list: [
        '•	Арьс залуужуулах: Арьсны өнгө сэргээх, үрчлээг багасгах, уян хатан чанарыг сайжруулах.',
        '•	Үсний эмчилгээ: Үсний уналтыг зогсоож, шинэ үс ургалтыг өдөөх.',
        '•	Үе мөчний өвдөлт намдаах: Үе мөчний үрэвсэл, ясны үрэвсэл, булчин, шөрмөсний гэмтэлд.',
        '•	Шарх эдгэрэлт: Шарх, түлэгдэлт, мэс заслын дараах эдгэрэлтийг түргэсгэх.',
        '•	Сорвины эмчилгээ: Сорвины хэмжээ, харагдах байдлыг багасгах.'
      ]
    }
  },
  {
    id: 119,
    tag: 'Эсийн эмчилгээ',
    category: 'ERP',
    question: 'ERP-г хэрхэн эмчилгээнд ашигладаг вэ?',
    answer: {
      list: [
        ' 1. Цусны дээж авах: Өвчтөний захын судаснаас 8-10 мл цус авна.',
        '2.	Экзосом ялгах: Цусны дээжийг GMP лабораторид боловсруулж, экзосомыг баяжуулна. ',
        '3.	Эсийн нөхөн төлжилт: Бэлтгэсэн экзосомоор баялаг плазмыг шаардлагатай хэсэгт тарьж, эд эсийн нөхөн төлжилтийг дэмжинэ.',
        'Экзосом нь өсөлтийн хүчин зүйлс, микрoРНХ болон мэдээллийн уургуудыг дотроо агуулж, эсийн нөхөн төлжилт, шинэчлэлтийг идэвхжүүлдэг.'
      ]
    }
  },
  {
    id: 120,
    tag: 'Эсийн эмчилгээ',
    category: 'ERP',
    question: 'ERP эмчилгээний ашиг тус?',
    answer: {
      list: [
        '•	Нөхөн төлжилт дэмжих: Экзосом нь эсийн нөхөн төлжилтийг өдөөж, эдгэрэлтийг түргэсгэнэ.',
        '•	Үрэвслийн эсрэг үйлдэл: Үрэвслийг бууруулж, эдийн гэмтлийг багасгадаг.',
        '•	Дархлаа зохицуулах: Дархлааны хариу урвалыг зохицуулдаг.',
        '•	Шарх эдгэрэлт: Түлэгдэлт, шарх, сорвины эдгэрэлтийг түргэсгэнэ.',
        '•	Арьсны эрүүл мэнд: Арьсны бүтэц, өнгийг сайжруулж, үрчлээг багасгана.',
        '•	Үс ургалт дэмжих: Үсний уналтыг багасгаж, шинэ үс ургалтыг өдөөдөг.',
        '•	Үе мөчний эрүүл мэнд: Үе мөчний үрэвсэл, өвдөлтийг намдааж, хөдөлгөөний чадварыг нэмэгдүүлдэг. Өвчин намдаах эмийн хэрэглээг багасгана.'
      ]
    }
  },
  {
    id: 121,
    tag: 'Эсийн эмчилгээ',
    category: 'ERP',
    question: 'ERP эмчилгээний давуу талууд?',
    answer: {
      list: [
        ' •	Байгалийн гаралтай: Өөрийн цуснаас гарган авч өөрт нь хэрэглэдэг тул харшил болон дархлааны хариу урвалын эрсдэл маш бага.',
        '•	Олон талын ашиг тустай: Арьс, үс, үе мөч зэрэг олон төрлийн асуудлыг нэгэн зэрэг шийдвэрлэх боломжтой.',
        '•	Хурдан эдгэрэлт: Эмчилгээний дараа богино хугацаанд үр дүнгээ өгдөг.',
        '•	Аюулгүй: GMP стандартын лабораторид боловсруулж, чанарын хяналт хийгддэг тул эрсдэл багатай.'
      ]
    }
  },
  {
    id: 122,
    tag: 'Эсийн эмчилгээ',
    category: 'ERP',
    question: 'ERP эмчилгээ хэр хугацаанд үргэлжлэх вэ?',
    answer: {
      main: 'ERP эмчилгээний үргэлжлэх хугацаа:',
      list: [
        '•	Ажилбар: Эмчилгээний явц дунджаар 30-60 минут үргэлжилдэг.',
        '•	Эхний үр дүн: Эмчилгээ хийснээс хойш 4 дэх хоногоос коллаген, эластин уургийн ялгаралт ихсэж  долоо хоногийн дараа эхний үр дүн мэдэгдэж эхэлнэ.',
        '•	Бүрэн үр дүн: 2 долоо хоногийн дараагаас эхлэн арьсны гүн давхарга эрүүлжиж үрчлээ багасан, арьсны уян хатан чанар ихсэж 3-6 сарын хугацаанд үр дүн хадгалагдана.'
      ]
    }
  },
  {
    id: 123,
    tag: 'Эсийн эмчилгээ',
    category: 'ERP',
    question: 'ERP эмчилгээ хийхгүй байх заалт юу вэ?',
    answer: {
      main: 'ERP эмчилгээ нь аюулгүй боловч дараах тохиолдолд зохимжгүй байж болно:',
      list: [
        '•	Хүнд хэлбэрийн өвчтэй: Дархлаа тогтолцооны ноцтой эмгэгтэй хүмүүс.',
        '•	Жирэмсэн болон хөхүүл эхчүүд: Энэ үед эмчилгээ хийхгүй байхыг зөвлөдөг.'
      ]
    }
  },
  {
    id: 124,
    tag: 'Эсийн эмчилгээ',
    category: 'ERP',
    question: 'ERP эмчилгээнд гаж нөлөө байдаг уу?',
    answer: {
      main: 'ERP эмчилгээ нь ихэвчлэн гаж нөлөөгүй байдаг. Гэсэн хэдий ч зарим тохиолдолд:',
      list: [
        '•	Тарилга хийлгэсэн хэсэгт улайх, хавдах, бага зэрэг өвдөлт мэдрэгдэж магадгүй.',
        'Эдгээр шинж тэмдгүүд нь богино хугацаанд арилах боломжтой.'
      ]
    }
  },
  //   Genetic
  {
    id: 72,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'GenomeCheck H шинжилгээ гэж юу вэ?',
    answer: {
      main: 'Бүх насныханд зориулагдсан GENOMECHECK H шинжилгээ нь 11 төрлийн хавдрын удамшлын эрсдэлийг тодорхойлох өндөр нарийвчлалтай генетиĸийн шинжилгээ юм. Энэ хүү шинжилгээ нь уушги, ходоод, элэг, нойр булчирхай, хөх, бөөр, улаан хоолой, давсаг, цөсний хүүдий, бамбай булчирхай, бүдүүн шулуун гэдэсний хорт хавдрын эрсдэлийг үнэлнэ.'
    }
  },
  {
    id: 73,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'Яагаад GenomeCheck H шинжилгээг хийлгэх вэ?',
    answer: {
      main: 'Хорт хавдрыг үүсэхээс өмнө эрсдэлийг эрт илрүүлэх нь урьдчилан сэргийлэх, амьдралын хэв маягаа өөрчлөх, өвчнийг хянах боломжийг олгодог.'
    }
  },
  {
    id: 74,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'GenomeCheck H шинжилгээг хийлгэхэд насны хязгаар бий юу?',
    answer: {
      main: 'Дөнгөж төрсөн нярайгаас эхлэн бүх насныхан хийлгэх боломжтой.'
    }
  },
  {
    id: 75,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'Шинжилгээний сорьцыг хэрхэн цуглуулдаг вэ?',
    answer: { main: 'Амны хөндийгөөс арчдас авч цуглуулдаг.' }
  },
  {
    id: 76,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'Хэн шинжилгээнд хамрагдах шаардлагатай вэ?',
    answer: {
      main: 'Хэн ч уг шинжилгээг хавдраас урьдчилан сэргийлэх зорилгоор хийлгэж болох ба онцгойлон гэр бүл, удамд нь хэн нэгэн хавдраар өвчилж байсан тохиолдолд шинжлүүлэх нь хавдаргүй урт наслах боломжийг олгоно.'
    }
  },
  {
    id: 77,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'Шинжилгээний хариуг хэр хугацаанд гаргадаг вэ?',
    answer: {
      main: 'GenomeCheck H шинжилгээний хариу хэр хугацаанд гардаг вэ? Шинжилгээний хариу 14-21 хоногийн дотор гардаг.'
    }
  },
  {
    id: 78,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'GenomeCheck H шинжилгээ ямар хавдруудыг илрүүлж чадах вэ?',
    answer: {
      main: '11 төрлийн хорт хавдрын (бүдүүн шулуун гэдэс, уушги, ходоод, элэг, бамбай булчирхай, цөс, улаан хоолой, нойр булчирхай, бөөр, давсаг, хөхний хорт хавдар) 57 генийн полиморфизмийг шинжилж тухайн хүний хавдар тусах эрсдэлийг үнэлдэг.'
    }
  },
  {
    id: 79,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'GenomeCheck H шинжилгээ үнэн зөв үү?',
    answer: {
      main: 'GenomeCheck H шинжилгээ нь генийн хувьд монголойд хэв шинжийн (Cолонгос, Хятад, Япон, Зүүн өмнөд ази) хүн амын дунд хийгдсэн 11 төрлийн хорт хавдрын 60 гаруй Genome-Wide Association Study-н үр дүнг ашиглаж 57 генийн эрсдэлт хувилбарыг шинжилж тухайн хүний хавдар тусах эрсдэлийг микроaррэй технологиор 90-95% магадлалтай үнэлдэг.'
    }
  },
  {
    id: 80,
    tag: 'Genetic',
    category: 'Genomecheck H',
    question: 'Genomecheck H эерэг хариу гарвал би юу хийх вэ?',
    answer: {
      main: 'Урьдчилан сэргийлэх арга хэмжээ авах, амьдралын хэв маягийг өөрчлөх, нарийн мэргэжлийн эмчийн хяналтад хамрагдаж тогтмол үзлэг, шинжилгээ хийлгэх шаардлагатай.'
    }
  },
  {
    id: 81,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'Genomecheck H сөрөг хариу гарвал эрсдэлгүй гэсэн үг үү?',
    answer: {
      main: 'Хэдийгээр хавдрын генетик эрсдэл илрээгүй ч амьдралын хэв маяг, хүрээлэн буй орчны бохирдолтой холбоотойгоор хавдраар өвдөх магадлал байдаг.'
    }
  },
  {
    id: 82,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question:
      'GenomeCheck H шинжилгээ хавдрын удамших магадлалыг тодорхойлдог уу?',
    answer: { main: 'Тийм. Удамшлын генетик эмгэгийн талаар мэдээлэл өгдөг.' }
  },
  {
    id: 83,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question:
      'GenomeCheck H шинжилгээгээр хавдар үүсэхээс бүрэн сэргийлж чадах уу?',
    answer: {
      main: 'Шинжилгээг өгснөөр хавдраас бүрэн сэргийлж буй хэрэг биш юм. Генетик шинжилгээ нь хавдар үүсэх магадлалын мэдээллийг өгдөг ба өвчнийг эрт илрүүлэх, урьдчилан сэргийлэх, эмчилгээний үр дүнг сайжруулахад чухал үүрэг гүйцэтгэдэг.'
    }
  },
  {
    id: 84,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'GenomeCheck H шинжилгээг өгөхдөө юуг анхаарах вэ? ',
    answer: {
      main: 'Шинжилгээнд хамрагдахын өмнө онцгой бэлтгэл шаардлагагүй бөгөөд 30 минутын өмнө уух зүйл уугаагүй, хоол идээгүй, уруулаа будаагүй, тамхи татаагүй байхад л болно.'
    }
  },
  {
    id: 85,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck H',
    question: 'GenomeCheck H шинжилгээний үр дүнтэй хэн танилцах вэ?',
    answer: {
      main: 'Зөвхөн үйлчлүүлэгч болон Селл Клиник эмнэлгийн зөвлөгөө өгч буй эмч.'
    }
  },
  {
    id: 86,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck M',
    question: 'GenomeCheck M гэж юу вэ?',
    answer: {
      main: 'GENOMECHECK M (НИПТ) буюу ургийн хромосомын эмгэг, хүйс тодорхойлох уг шинжилгээ нь жирэмсний эрт үед (10-24 долоо хоног) эхийн цуснаас ургийн чөлөөт ДНХ -г ялган авч хромосомын тооны болон бүтцийн өөрчлөлтийг оношлох өндөр нарийвчлалтай дэвшилтэт шинжилгээ юм. Энэ шинжилгээ нь Даун, Эдвардс, Патаугийн хам шинж зэрэг 10, 123, 424 хромосомын эмгэгүүдийг тодорхойлохоос гадна ургийн ХҮЙСИЙГ тодорхойлдог.'
    }
  },
  {
    id: 87,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck M',
    question: 'GenomeCheck M-ийг хэзээ хийдэг вэ?',
    answer: { main: 'Жирэмсний 10-24 дахь долоо хоногт.' }
  },
  {
    id: 88,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck M',
    question: 'GenomeCheck M шинжилгээнд хэн хамрагдах шаардлагатай вэ?',
    answer: {
      list: [
        '•	Бүх жирэмсэн эх',
        '•	Хромосомын эмгэгийн эрсдэлтэй гэж үзсэн ',
        '•	Өмнөх жирэмслэлтэд хромосомын эмгэг илэрч байсан ',
        '•	Хосын аль нэгний гэр бүлд удамшлын өвчний түүхтэй',
        '•	35-аас дээш насны жирэмсэн эх'
      ]
    }
  },
  {
    id: 89,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck M',
    question: 'GenomeCheck M-ээр ямар эмгэгүүдийг илрүүлдэг вэ?',
    answer: {
      main: 'Хромосомын тооны өөрчлөлтүүд буюу Дауны хам шинж (21-р хромосомын илүүдэл), Эдвардсын хам шинж (18-р хромосомын илүүдэл), Патаугийн хам шинж (13-р хромосомын илүүдэл). Бэлгийн хромосомын эмгэгүүд буюу Тернерийн хам шинж (XO хромосомын гээгдэл), Клайнфелтерийн хам шинж (XXY хромосом) гэх мэт нийт 424 төрлийн хромосомын эмгэгүүдийг тодорхойлно'
    }
  },
  {
    id: 90,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck M',
    question: 'GenomeCheck M сорьцыг хэрхэн цуглуулдаг вэ? ',
    answer: {
      main: 'Шинжилгээнд зөвхөн эхийн цусны дээж шаардлагатай тул ургийг гэмтээх эрсдэлгүй.'
    }
  },
  {
    id: 91,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck M',
    question: 'GenomeCheck M шинжилгээний хариу хэр үнэн бэ?',
    answer: {
      main: 'Шинжилгээний нарийвчлал (NGS -  Next Generation Sequencing) 99.9% магадлалтай.'
    }
  },
  {
    id: 92,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck M',
    question: 'GenomeCheck M-ээр ургийн хүйсийг тодорхойлж болох уу? ',
    answer: {
      main: 'Тийм. Хүйсийг жирэмсний эрт үе буюу 10 долоо хоногтойгоос эхлэн мэдэх боломжийг олгодог.'
    }
  },
  {
    id: 93,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck M',
    question: 'GenomeCheck M шинжилгээг өгөхдөө жирэмсэн эх юуг анхаарах вэ?',
    answer: {
      main: 'Шинжилгээнд хамрагдахын өмнө онцгой бэлтгэл шаардлагагүй бөгөөд 24 цагийн дотор өөх тос ихтэй хоол идээгүй байхад л болно.'
    }
  },
  {
    id: 94,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck M',
    question: 'GenomeCheck М шинжилгээний үр дүнтэй хэн танилцах вэ?',
    answer: {
      main: 'Зөвхөн үйлчлүүлэгч болон Селл Клиник эмнэлгийн зөвлөгөө өгч буй эмч.'
    }
  },
  {
    id: 95,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'GenomeCheck G шинжилгээ гэж юу вэ?',
    answer: {
      main: 'GENOMECHECK G шинжилгээ нь хүний хромосомын тоо, бүтцийг нарийвчлан судалж, удамшлын өвчин, төрөлхийн гажиг, үргүйдэл, зулбалт, хөгжлийн хоцрогдолтой холбоотой өөрчлөлтүүдийг илрүүлэхэд ашиглагддаг дэвшилтэт шинжилгээ юм.'
    }
  },
  {
    id: 96,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'GenomeCheck G шинжилгээг яагаад хийлгэх вэ?',
    answer: {
      list: [
        '•	Ураг байх үед GenomeCheck M шинжилгээг хийлгэж амжаагүй бол',
        '•	Хромосомын эмгэгтэй хүүхэд төрүүлж байсан түүхтэй бол',
        '•	Жирэмслэлт давтан амжилтгүй болж байгаа бол',
        '•	Үргүйдэл болон гэр бүлийн удамшлын өвчний түүхтэй бол',
        '•	Жирэмсний үед ургийн хромосомын эмгэгийн эрсдэл гарсан бол.',
        '•	Онош тодорхойгүй өвчний үед'
      ]
    }
  },
  {
    id: 97,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'Хромосомын тооны өөрчлөлт гэж юу вэ?',
    answer: {
      main: 'Хромосомын тооны өөрчлөлт нь нэг бүтэн хромосомын илүүдэл болон гээгдлийг хэлнэ. Жишээ нь:',
      list: [
        '•	Дауны хам шинж (21-р хромосомын илүүдэл)',
        '•	Эдвардсын синдром (18-р хромосомын илүүдэл)',
        '•	Патаугийн синдром (13-р хромосомын илүүдэл)',
        '•	Тернерийн хам шинж (45XО, бэлгийн хромосомын гээгдэл)'
      ]
    }
  },
  {
    id: 98,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'Хромосомын бүтцийн өөрчлөлт гэж юу вэ?',
    answer: {
      main: 'Хромосомын бүтцийн өөрчлөлт нь хромосомын жижиг хэсгийн байрлал өөрчлөгдөх эсвэл хромосомын зарим хэсэг устах, хоёрчлогдох зэрэгтэй холбоотой. Жишээ нь: ',
      list: [
        '•	Делеци: Хромосомын жижиг хэсэг устах',
        '•	Дупликаци: Хромосомын жижиг хэсэг хоёрчлогдох',
        '•	Инверс: Хромосомын жижиг хэсэг эргэх',
        '•	Транслокаци: Өөр, өөр хромосомын хэсгүүд солигдох.'
      ]
    }
  },
  {
    id: 99,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'GenomeCheck G шинжилгээнд хэн хамрагдах шаардлагатай вэ? ',
    answer: {
      list: [
        '•	Нас харгалзахгүйгээр амжилтгүй болсон жирэмслэлтийн шалтгааныг тодруулах',
        '•	Үргүйдэл болон гэр бүлийн удамшлын өвчнийг оношлох',
        '•	Онош тодрохгүй байгаа өвчний үед хийлгэхийг зөвлөж байна.'
      ]
    }
  },
  {
    id: 100,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'GenomeCheck G шинжилгээг ямар аргаар хийдэг вэ?',
    answer: { main: 'Хромосомын Микроаррэй технологиор.' }
  },
  {
    id: 101,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'GenomeCheck G шинжилгээний хариу хэр найдвартай вэ?',
    answer: {
      main: 'Шинжилгээний төрөл болон аргаас хамааран 90-95%-ийн нарийвчлалтай'
    }
  },
  {
    id: 140,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'GenomeCheck G шинжилгээний хариу хэр хугацаанд гардаг вэ?',
    answer: {
      main: 'Шинжилгээний хариу 14-21 хоногийн дотор гардаг.'
    }
  },
  {
    id: 102,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'GenomeCheck G шинжилгээнд эрсдэл бий юу?',
    answer: { main: 'Амны хөндийгөөс арчдас авч шинжилдэг тул эрсдэлгүй.' }
  },
  {
    id: 103,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'GenomeCheck G шинжилгээг өгөхдөө юуг анхаарах вэ?',
    answer: {
      main: 'Шинжилгээнд хамрагдахын өмнө онцгой бэлтгэл шаардлагагүй бөгөөд 30 минутын өмнө уух зүйл уугаагүй, хоол идээгүй, уруулаа будаагүй, тамхи татаагүй байхад л болно.'
    }
  },
  {
    id: 104,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck G',
    question: 'GenomeCheck G шинжилгээний үр дүнтэй хэн танилцах вэ?',
    answer: {
      main: 'Зөвхөн үйлчлүүлэгч болон Селл Клиник эмнэлгийн зөвлөгөө өгч буй эмч.'
    }
  },
  {
    id: 105,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck PV',
    question: 'GenomeCheck PV шинжилгээ гэж юу вэ?',
    answer: {
      main: 'Уг шинжилгээ нь үр хөврөл шилжүүлэн суулгалтын өмнөх хромосомын эмгэгийн шинжилгээ бөгөөд (Preimpilation Genetic Testing, PGT) лабораторийн орчинд үр тогтоолт хийн гарган авсан үр хөврөлийн тооны болон бүтцийн өөрчлөлт, удамшлын өөрчлөлтийг судалж, эрүүл үр хөврөлийг сонгон эхийн умайд шилжүүлэн суулгах зорилготой дэвшилтэт арга юм.'
    }
  },
  {
    id: 106,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck PV',
    question: 'GenomeCheck PV шинжилгээг яагаад хийлгэх вэ?',
    answer: {
      list: [
        '• 	Удамшлын өвчин, хромосомын эмгэгтэй үр хөврөл шилжүүлэн суулгахаас сэргийлдэг. ',
        '•	Хромосомын өөрчлөлтөөс үүдэлтэй зулбалтын эрсдэлийг бууруулна. ',
        '•	Удамшлын өвчин дамжуулах магадлалтай хосуудад эрүүл хүүхэд төрүүлэх боломж олгоно.'
      ]
    }
  },
  {
    id: 107,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck PV',
    question: 'GenomeCheck PV шинжилгээнд хэн хамрагдах шаардлагатай вэ?',
    answer: {
      list: [
        '•	Хосуудын хэн нэгэн нь гэр бүлийн удамшлын өвчний түүхтэй бол.',
        '•	Хромосомын эмгэгээс үүдсэн үр хөндөлт эсвэл жирэмслэлт амжилтгүй болсон түүхтэй бол.',
        '•	Ахимаг настай эмэгтэйд (35-аас дээш нас) жирэмслэлт төлөвлөж байгаа бол.',
        '•	Үр шилжүүлэн суулгах (IVF) үйл явцад олон удаа амжилтгүй болсон бол.'
      ]
    }
  },
  {
    id: 108,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck PV',
    question: 'GenomeCheck PV шинжилгээг хэрхэн хийдэг вэ?',
    answer: {
      main: 'Үр хөврөл лабораторид үүсэн бий болсны дараа 5-6 хоногтой үр хөврөлийн эсээс авч шинжилгээг хийнэ.'
    }
  },
  {
    id: 109,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck PV',
    question: 'GenomeCheck PV шинжилгээний хариу хэр хугацаанд гаргадаг вэ?',
    answer: { main: 'Шинжилгээний хариу 21-28 хоногийн дотор гардаг.' }
  },
  {
    id: 110,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck PV',
    question: 'GenomeCheck PV ямар өвчнүүдийг оношилдог вэ?',
    answer: {
      main: 'Хромосомын тооны болон бүтцийн өөрчлөлтүүдийг оношилдог (Жишээ нь, Дауны синдром).'
    }
  },
  {
    id: 111,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck PV',
    question: 'GenomeCheck PV шинжилгээний хариу хэр үнэн бэ?',
    answer: {
      main: 'Шинжилгээний нарийвчлал (NGS- Next Generation Sequencing) 99.9% магадлалтай.'
    }
  },
  {
    id: 112,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck PV',
    question: 'GenomeCheck PV нь үр хөврөлийн хөгжилд нөлөөлөх үү?',
    answer: {
      main: 'Үгүй. Учир нь үр хөврөлийн маш жижиг хэсгийг аван шинжилдэг. Харин хөлдөөсөн үр хөврөлд шинжилгээг хийхэд үр хөврөлийн чанар мууддаг'
    }
  },
  {
    id: 113,
    tag: 'Генетик шинжилгээ',
    category: 'Genomecheck PV',
    question: 'GenomeCheck PV шинжилгээний үр дүнтэй хэн танилцах вэ? ',
    answer: {
      main: 'Зөвхөн үйлчлүүлэгч болон Селл Клиник эмнэлгийн зөвлөгөө өгч буй эмч.'
    }
  }
]
export default faqArray

export const services = [
  {
    id: 1,
    name: 'Хүйн цус',
    tag: 'Эсийн банк',
    price: 5000000,
    monthlyPayment: '295,000',
    desc: 'Хүйн цусны үүдэл эсийг ирээдүйн эмчилгээнд ашиглах зорилгоор хадгалах.',
    list: [
      'Жилийн төлбөр: 300’000/жил',
      '18 жил 5’400’000',
      '30 жил 9’000’000'
    ],
    gText: 'Цусны өвчин, дархлалын эмгэгүүдэд',
    content: {
      title: 'Хүйн цус',
      photo: cellbankblood,
      desc: 'Хүйн цус нь төрсний дараа хүйн судсанд болон ихэст үлдсэн ургийн цус юм.  Энэ цус нь цусны үүдэл эс (HSCs) болон дархлаа зохицуулагч эсийн үнэт эх үүсвэр болдог. Хүйн цусыг хүүхдийн хэмт ясны чөмгийн оронд хэрэглэх бүрэн боломжтой байдаг. ',
      desc1:
        'Хүйн цусны үүдэл эсийг одоогоор цусны хорт хавдар, удамшлын эмгэг зэрэг 80 гаруй амь насанд аюултай өвчнийг эмчлэхэд ашиглаж байна. Түүнчлэн хүйн цусны үүдэл эсийг ашигласан 400 гаруй эмнэлзүйн туршилт судалгаа нь эмчлэгдэх боломжгүйд тооцогдож буй олон өвчнийг эмчлэхэд ашиглах боломжийг хайж байна. Дархлаа зохицуулагч эс болох Т зохицуулагч эсийг нь эрхтэн шилжүүлэн суулгасны дараах эмчилгээнд өргөн хэрэглэгддэг.',

      title2: 'Үйлчилгээг хэрхэн авах вэ?',
      treatments: [
        '1. Доор байрлах цаг захиалах товчлуурт дарж эсвэл 7776-0000 дугаарт залгаж цаг авна.',
        '2. Манай эмнэлэгт ирж үйлчилгээний гэрээ байгуулсаны дараа хүйн цус, эд цуглуулах иж бүрдлийг хүлээн авна.',
        '3. Төрөх эмнэлэгт очихдоо хүйн цус, эд цуглуулах иж бүрдлийг авч очих ба төрөх цаг хугацааг манай эмнэлэгт мэдэгдэнэ.',
        '4. Хүүхэд төрсний дараа төрөх эмнэлгийн эх баригч, сувилагч эсвэл манай мэргэжилтэн хүйн цус, эдийг цуглуулан 24 цагийн дотор Селл Клиник эмнэлэгт хүргэнэ.',
        '5. Цуглуулсан хүйн цус, эдээс GMP лабораторид үүдэл эсийг ялган, чанарын хяналтын шинжилгээ хийснээр шингэн азотын -196 градуст хадгална.',
        '6. Үүдэл эсийн тоо, гарц болон чанарыг тодорхойлсон хадгалалтын гэрчилгээг эцэг, эхэд өгнө.'
      ],
      price: 5000000,
      startPrice: 2000000,
      priceDesc: 'Хадгалалтын эхний 1 жилийн төлбөр багтсан',
      priceBox:
        'Төлбөрийг 6-12 сарын хугацаанд гуравдагч санхүүгийн байгууллагагүйгээр хуваан төлөөрэй.'
    },
    isBrochure: false,
    isAvailable: true
  },
  {
    id: 2,
    name: 'Хүйн эд',
    tag: 'Эсийн банк',
    desc: 'Хүйн эдийн мезенхимийн үүдэл эсийг ирээдүйн эмчилгээнд ашиглах зорилгоор хадгалах.',
    list: [
      'Жилийн төлбөр: 300’000/жил',
      '18 жил 5’400’000',
      '30 жил 9’000’000'
    ],
    price: 6000000,
    monthlyPayment: '395,000',
    gText: 'Нөхөн сэргээх анагаах ухааны өргөн хэрэглээ',
    content: {
      title: 'Хүйн эд',
      photo: cellbankTissue,
      desc: 'Хүйн эд нь хүйн судасны эргэн тойронд байрлах зөөлөн эд бөгөөд “Wharton Jelly” гэж нэрлэдэг. Энэ эд нь мезенхимийн үүдэл эсээр (MSC) баялаг эх үүсвэр юм. ',
      desc2: 'Мезенхимийн үүдэл эс (MSCs)-ыг ямар эмчилгээнд ашиглаж болох вэ?',
      benefits: [
        'Тулгуур эрхтний эмгэг: Үений үрэвсэл, мөгөөрс, яс, булчинг нөхөн төлжүүлэх ',
        'Арьсны эмгэг: Шарх эдгээх, арьс нөхөн төлжүүлэх, арьсны хөгшрөлт',
        'Аутоиммун эмгэг: Ревматойд артрит, Системийн чонон яр, Системийн склероз, Кроны өвчин болон Суулгац эзний эсрэг урвал (GVHD)',
        'Мэдрэлийн эмгэгүүд: Паркинсоны өвчин, Альцгеймер, Нугасны гэмтэл, Цус харвалт',
        'Зүрх судасны өвчин: Зүрхний шигдээсний дараах зүрхний булчингийн эдийг нөхөн төлжүүлэлт, захын артерийн эмгэг',
        'Чихрийн шижин ба бодисын солилцооны эмгэгүүд: Инсулин ялгаруулдаг эсүүдийг төлжүүлэхэд дэмжлэг үзүүлэх.',
        'Гоо сайхан ба нөхөн төлжүүлэх анагаах ухаан: Арьсны өнгийг сэргээх, сорви багасгах, арьс нөхөн сэргээх, хөгшрөлтийн эсрэг, арьсны үрчлээг багасгах, гоо сайхны эмчилгээнд үр дүнтэй.'
      ],
      title2: 'Үйлчилгээг хэрхэн авах вэ?',
      treatments: [
        '1. Доор байрлах цаг захиалах товчлуурт дарж эсвэл 7776-0000 дугаарт залгаж цаг авна.',
        '2. Манай эмнэлэгт ирж үйлчилгээний гэрээ байгуулсаны дараа хүйн цус, эд цуглуулах иж бүрдлийг хүлээн авна.',
        '3. Төрөх эмнэлэгт очихдоо хүйн цус, эд цуглуулах иж бүрдлийг авч очих ба төрөх цаг хугацааг манай эмнэлэгт мэдэгдэнэ.',
        '4. Хүүхэд төрсний дараа төрөх эмнэлгийн эх баригч, сувилагч эсвэл манай мэргэжилтэн хүйн цус, эдийг цуглуулан 24 цагийн дотор Селл Клиник эмнэлэгт хүргэнэ.',
        '5. Цуглуулсан хүйн цус, эдээс GMP лабораторид үүдэл эсийг ялган, чанарын хяналтын шинжилгээ хийснээр шингэн азотын -196 градуст хадгална.',
        '6. Үүдэл эсийн тоо, гарц болон чанарыг тодорхойлсон хадгалалтын гэрчилгээг эцэг, эхэд өгнө.'
      ],
      title4: 'Мезенхимийн үүдэл эс нь хувилан олшрох онцгой чадвартай.',
      price: 6000000,
      priceBox:
        'Төлбөрийг 6-12 сарын хугацаанд гуравдагч санхүүгийн байгууллагагүйгээр хуваан төлөөрэй.'
    },
    isAvailable: true
  },
  {
    id: 3,
    name: 'Full багц',
    subName: '(хүйн цус+эд)',
    tag: 'Эсийн банк',
    desc: 'Хүйн цус болон хүйн эдийн үүдэл эсүүдийг хамтад нь хадгалж аль алинийг нь ирээдүйд ашиглах боломжийг бүрдүүлнэ.',
    gText: 'Эмчилгээний илүү өргөн боломж',
    list: [
      'Жилийн төлбөр: 500’000/жил',
      'Эхний 1 жил үнэгүй',
      '18 жил 8’500’000',
      '30 жил 14’500’000'
    ],
    price: 9500000,
    hemnelt: 2100000,
    monthlyPayment: '640,000',
    content: {
      title: 'Full багц',
      photo: cellbankcomlete,
      desc: 'Энэхүү багц нь хүйн цус болон хүйн эдийн үүдэл эсийг хамтад нь хадгалах үйлчилгээ юм. Хүйн цус нь цусны үүдэл эсүүд (HSCs)-ийн баялаг эх үүсвэр бол хүйн эд нь өөр төрлийн үүдэл эс болох мезенхимийн үүдэл эсүүд (MSCs)-ийн баялаг эх үүсвэр юм. ',
      // desc1:
      //   'Эдгээр шинжилгээг эс хадгалалттай хамт хийлгэснээр шинэ төрсөн хүүхдийн эрүүл мэндийн ирээдүйн төлөвийг тодорхойлох давуу талтай.',
      highlight3Top:
        'Яагаад хүйн цусны үүдэл эс болон хүйн эдийн үүдэл эсийг хамтад нь хадгалах ёстой вэ?',
      highlight3: {
        main: '1. Хамтад нь хадгалснаар цус, дархлааны эмгэгүүдээс гадна, мөгөөрс, яс, булчин, мэдрэл, арьсны өвчнүүдийг эмчлэх боломжтой',
        sub: [
          'Хүйн цусны үүдэл эс → Цус төлжүүлэх болон дархлаа тогтолцооны өвчинд ашиглагдана.',
          'Хүйн эдийн үүдэл эс → Эд, эрхтэн нөхөн сэргээх, үрэвслийн эсрэг эмчилгээнд хэрэгтэй.'
        ]
      },

      highlight4: {
        main: '2. Эмчилгээний илүү олон сонголт',
        desc: 'Зөвхөн нэг төрлийн үүдэл эс хадгалах нь хязгаарлагдмал хэрэглээтэй бөгөөд хоёр төрлийн эсийг хадгалснаар:',
        sub: [
          'Ясны чөмөг, цусны эмгэгийн эмчилгээ – HSCs',
          'Үрэвсэл намдаах, эрхтэн нөхөн сэргээх эмчилгээ – MSCs',
          'Дархлаа зохицуулах эмчилгээ – HSCs + MSCs хослуулан хэрэглэж болно.'
        ]
      },

      highlight5: {
        main: '3. Гэр бүлийн гишүүд ашиглах боломжтой',
        sub: [
          'HSCs ийн хэрэглээнд эдийн тохироо нийцэх шаардлагатай учир ихэвчлэн тухайн хүүхдэд болон ойрын хамаатанд тохиромжтой.',
          'MSCs нь эдийн тохирооны нийцэмжийг хатуу шаарддаггүй тул гэр бүлийн гишүүд болон бусад хүмүүст хэрэглэх боломжтой.'
        ]
      },
      highlight6: {
        main: '4. Ирээдүйд судлагдаж буй шинэ эмчилгээнд бэлэн байх',
        desc: [
          'Үүдэл эсийн судалгаа хурдацтай хөгжиж байгаа тул ирээдүйд HSCs болон MSCs-ийн хэрэглээ улам өргөжих хандлагатай байгаа бөгөөд хоёр төрлийн үүдэл эсийг хамт нь хадгалснаар шинэ эмчилгээ гарч ирэх үед бэлэн байх давуу талтай.'
        ]
      },
      title2: 'Үйлчилгээг хэрхэн авах вэ?',
      treatments: [
        '1. Доор байрлах цаг захиалах товчлуурт дарж эсвэл 7776-0000 дугаарт залгаж цаг авна.',
        '2. Манай эмнэлэгт ирж үйлчилгээний гэрээ байгуулсаны дараа хүйн цус, эд цуглуулах иж бүрдлийг хүлээн авна.',
        '3. Төрөх эмнэлэгт очихдоо хүйн цус, эд цуглуулах иж бүрдлийг авч очих ба төрөх цаг хугацааг манай эмнэлэгт мэдэгдэнэ.',
        '4. Хүүхэд төрсний дараа төрөх эмнэлгийн эх баригч, сувилагч эсвэл манай мэргэжилтэн хүйн цус, эдийг цуглуулан 24 цагийн дотор Селл Клиник эмнэлэгт хүргэнэ.',
        '5. Цуглуулсан хүйн цус, эдээс GMP лабораторид үүдэл эсийг ялган, чанарын хяналтын шинжилгээ хийснээр шингэн азотын -196 градуст хадгална.',
        '6. Үүдэл эсийн тоо, гарц болон чанарыг тодорхойлсон хадгалалтын гэрчилгээг эцэг, эхэд өгнө.'
      ],
      title4:
        'Хамтад нь хадгалах нь ирээдүйн эрүүл мэндийн том хөрөнгө оруулалт болно!',
      price: 9500000,
      priceDesc: 'Хадгалалтын эхний 3 жилийн төлбөр багтсан',
      priceBox:
        'Төлбөрийг 6-12 сарын хугацаанд гуравдагч санхүүгийн байгууллагагүйгээр хуваан төлөөрэй.'
    },
    isAvailable: true
  },
  {
    id: 4,
    name: 'Full + Genetic',
    tag: 'Эсийн банк',
    price: 13500000,
    hemnelt: 5300000,
    monthlyPayment: '984,000',
    desc: 'Хүйн цус болон хүйн эдийн үүдэл эсүүдийг хамтад нь хадгалж мөн удамшлын өвчний генетик шинжилгээ болон ирээдүйн хавдар тусах эрсдэлийг мэдэх.',
    gText: 'Хромосомын эмгэггүй, хавдаргүй ирээдүйг бэлэглэх боломж',
    list: [
      'Жилийн төлбөр: 500’000/жил',
      'Эхний 3 жил үнэгүй',
      'GenomeCheck H',
      'GenomeCheck G',
      '18 жил 7’500’000',
      '30 жил 13’500’000'
    ],
    content: {
      title: 'Full + Genetic',
      photo: cellbankgenetic,
      desc: 'Энэхүү багц нь хүйн цус болон хүйн эдийн үүдэл эсийг хамтад нь хадгалах үйлчилгээ дээр нэмэгдэж хүйн цуснаас нь доорх хоёр төрлийн генетик шинжилгээг давхар хийх багц юм. ',
      desc1:
        'Генетик шинжилгээг үүдэл эс хадгалалтын үйлчилгээтэй хамтад нь хийлгэснээр шинэ төрсөн хүүхдийн ирээдүйн эрүүл мэндийг урьдчилан таамаглах, сэргийлэх боломжийг олгодгоороо давуу талтай',
      highlight1: {
        main: '11 төрлийн хавдрын эрсдэл тодорхойлох генетик шинжилгээ GenomeCheck H ',
        sub: 'Хүүхдийн ирээдүйд хавдраар өвдөх эрсдэлийг генетикийн түвшинд тодорхойлно.'
      },

      highlight2: {
        main: 'Xромосомын тооны болон бүтцийн өөрчлөлтийн шинжилгээ GenomeCheck G',
        sub: 'Тооны болон бүтцийн өөрчлөлтэй холбоотой 1341 төрлийн хромосомын эмгэгийн (бүх хромосомын гээгдэл ба илүүдэл) оношилгоо.'
      },
      desc2:
        'Генетик шинжилгээний тусламжтайгаар хүүхдийнхээ ирээдүйд тохиолдох боломжтой эрүүл мэндийн асуудлыг эрт оношилж, урьдчилан сэргийлэх арга хэмжээ авах боломжтой.',
      benefits: [
        'Эрүүл зөв амьдралын хэв маягийг бүрдүүлэх',
        'Хавдар болон удамшлын өвчнийг эрт илрүүлж, урьдчилан сэргийлэх',
        'Хүүхдийнхээ ирээдүйн эрүүл мэндийг хамгийн найдвартайгаар хамгаалах'
      ],
      title2: 'Үйлчилгээг хэрхэн авах вэ?',
      treatments: [
          '1. Доор байрлах цаг захиалах товчлуурт дарж эсвэл 7776-0000 дугаарт залгаж цаг авна.',
          '2. Манай эмнэлэгт ирж үйлчилгээний гэрээ байгуулсаны дараа хүйн цус, эд цуглуулах иж бүрдлийг хүлээн авна.',
          '3. Төрөх эмнэлэгт очихдоо хүйн цус, эд цуглуулах иж бүрдлийг авч очих ба төрөх цаг хугацааг манай эмнэлэгт мэдэгдэнэ.',
          '4. Хүүхэд төрсний дараа төрөх эмнэлгийн эх баригч, сувилагч эсвэл манай мэргэжилтэн хүйн цус, эдийг цуглуулан 24 цагийн дотор Селл Клиник эмнэлэгт хүргэнэ.',
          '5. Цуглуулсан хүйн цус, эдээс GMP лабораторид үүдэл эсийг ялган, чанарын хяналтын шинжилгээ хийснээр шингэн азотын -196 градуст хадгална.',
        '6. Генетик шинжилгээний хариу болон үүдэл эсийн тоо, гарц болон чанарыг тодорхойлсон хадгалалтын гэрчилгээг эцэг эхчүүдэд өгнө.'
      ],
      title4:
        'Хүн анх төрөхдөө зарим төрлийн хавдрын эрсдэлээ удмын мэдээлэлдээ тээж ирдэг.',
      price: 13500000,
      priceDesc: 'Хадгалалтын эхний 3 жилийн төлбөр багтсан',
      priceBox:
        'Төлбөрийг 6-12 сарын хугацаанд гуравдагч санхүүгийн байгууллагагүйгээр хуваан төлөөрэй.'
    },
    isAvailable: true
  },
  {
    id: 5,
    name: 'Full + НИПТ',
    tag: 'Эсийн банк',
    desc: 'Жирэмсний эрт үед удамшлын өвчний генетик шинжилгээг хийж, хүйн цус болон хүйн эдийг хамт хадгалах.',
    gText: 'Эрүүл ураг тээж буйг баталгаажуулах боломж',
    list: [
      'Жилийн төлбөр: 500’000/жил',
      'Эхний 2 жил үнэгүй',
      'GenomeCheck M (НИПТ)',
      '18 жил 8’000’000',
      '30 жил 14’000’000'
    ],
    price: 11000000,
    hemnelt: 3000000,
    monthlyPayment: '787,000',
    content: {
      title: 'Full + НИПТ',
      photo: cellbanknipt,
      desc: 'Энэхүү багц нь хүйн цус болон хүйн эдийн үүдэл эсийг хамтад нь хадгалуулах шийдвэр гаргасан эцэг, эхчүүдэд жирэмсний эрт үед буюу 10-24 долоо хоногт ургийн хромосомын тооны болон бүтцийн өөрчлөлтийг оношлох GenomeCheck M (НИПТ) багц үйлчилгээ юм.  ',
      highlight3: {
        main: 'GenomeCheck M (НИПТ) шинжилгээнд хэн хамрагдах боломжтой вэ?',
        sub: [
          '          Бүх жирэмсэн эх ',
          '  Хромосомын эмгэгийн эрсдэлтэй гэж үзсэн жирэмсэн эх',
          '          Өмнөх жирэмслэлтэд хромосомын эмгэг илэрч байсан жирэмсэн эх',
          '          Хосын аль нэгний гэр бүлд удамшлын өвчний түүхтэй жирэмсэн эх',
          '          35-аас дээш насны жирэмсэн эх'
        ]
      },

      highlight4: {
        main: 'GenomeCheck M-ээр ямар эмгэгүүдийг илрүүлдэг вэ?',
        desc: '',
        sub: [
          '          Хромосомын тооны өөрчлөлтүүд буюу Дауны хам шинж (21-р хромосомын гурвал), Эдвардсын хам шинж (18-р хромосомын гурвал), Патаугийн хам шинж (Трисоми 13-р хромосомын гурвал). ',
          '    Хүйсийн хромосомын эмгэгүүд буюу Тернер синдром (X хромосом ганц байх), Клайнфелтер синдром (XXY хромосом) гэх мэт нийт 424 төрлийн хромосомын эмгэгийг тодорхойлно.',
          'НИПТ шинжилгээ нь (NGS) 99.9% магадлалтай ба хромосомын эмгэгээс гадна ургийн ХҮЙСИЙГ тодорхойлдог.'
        ]
      },

      title2: 'Үйлчилгээг хэрхэн авах вэ?',
      treatments: [
        '1. Доор байрлах цаг захиалах товчлуурт дарж эсвэл 7776-0000 дугаарт залган цаг авна.',
        '2. 10-24 долоо хоногтой жирэмсэн үедээ энэхүү үйлчилгээг сонгосон бол манай эмнэлэгт ирэн үйлчилгээний гэрээ байгуулж GenomeCheck М шинжилгээний сорьцоо өгөхөөс гадна хүйн цус, эд цуглуулах иж бүрдлийг хүлээн авна.',
        '3. GenomeCheck M шинжилгээний хариу 14-21 хоногт бэлэн болж манай эмнэлгийн эмч шинжилгээний үр дүнг үйлчлүүлэгчид танилцуулна.',
        '4. Төрөх өдрөө төрөх эмнэлэгт хүйн цус, эд цуглуулах иж бүрдлийг авч очих ба төрөх цаг хугацааг манай эмнэлэгт мэдэгдэнэ. ',
        '5. Хүүхэд төрсний дараа төрөх эмнэлгийн эх баригч, сувилагч эсвэл манай мэргэжилтэн хүйн цус, эдийг цуглуулан 24 цагийн дотор Селл Клиник эмнэлэгт хүргэнэ.',
        '6. Цуглуулсан хүйн цус, эдээс GMP лабораторид үүдэл эсийг ялган, чанарын хяналтын шинжилгээ хийснээр шингэн азотын -196 градуст хадгална.',
        '7. Үүдэл эсийн тоо, гарц болон чанарыг тодорхойлсон хадгалалтын гэрчилгээг эцэг, эхэд өгнө.'
      ],
      price: 11000000,
      priceDesc: 'Хадгалалтын эхний 3 жилийн төлбөр багтсан',
      priceBox:
        'Төлбөрийг 6-12 сарын хугацаанд гуравдагч санхүүгийн байгууллагагүйгээр хуваан төлөөрэй.'
    },
    isAvailable: true
  },
  {
    id: 6,
    name: 'Сүүн шүд',
    tag: 'Эсийн банк',
    price: 'soon',
    desc: 'Хүүхдийн сүүн шүд унах үед түүнд агуулагдах үүдэл эсүүд нь хүйн цус, хүйн эдийн дараа орох хамгийн боломжит хадгалах эс байдаг.',
    list: ['-', '-', '-', '-', '-', '-'],
    content: {
      title: 'Сүүн шүд',
      photo: cellbanktooth,
      desc: 'Сүүн шүд нь хүүхдийн амьдралын эхний хэдэн жилд ургаж, эцэст нь унаж орхигддог. Сүүн шүдний үүдэл эс нь сүүн шүдний пульп-д агуулагддаг мезенхимийн үүдэл эс бөгөөд нөхөн сэргээх анагаах ухаанд өргөн ашиглагддаг.   ',
      highlight3: {
        main: 'Сүүн шүдний үүдэл эсийн шинж чанар:',
        sub: [
          'Нөхөн сэргээх чадвар: Сүүн шүдний үүдэл эсүүд нь эд эс, тэр дундаа шүдний эдийн нөхөн сэргэлтэд оролцдог. ',
          'Шүдний эмчилгээ: Тэд шүдний суурь болон гүн эдийн нөхөн сэргэлтэд чухал үүрэгтэй. Энэ нь шүдний тулгуур эдийг сэргээх боломжийг олгодог.',
          'Генетикийн хувьд тохиромжтой: Сүүн шүдний үүдэл эс нь тухайн хүний өөрийнх нь эс тул эдийн тохирооны асуудал үүсдэггүй. '
        ]
      },
      text2:
        'Сүүн шүдний үүдэл эсүүд нь шүд, эрүү нүүрний нөхөн сэргээлтээс гадна бусад эд эрхтний нөхөн сэргээх эмчилгээнд мөн ашиглагдах боломжтой. ',
      title2:
        'Энэ үйлчилгээ нь одоогийн байдлаар хөгжүүлэлтийн шатандаа явж байна.',
      // treatments: [
      //   'Доор байрлах цаг захиалах товчлуурт дарж эсвэл 7776-0000 дугаарт залгаж цаг авна.',
      //   'Манай эмнэлэгт ирж үйлчилгээний гэрээ байгуулагдсаны дараа сүүн шүд цуглуулах бүрдлийг хүлээн авна.',
      //   'Хүүхдийн сүүн шүд унахаас өмнө шүдний эмнэлэгт эмч шүдийг авч шүд хадгалах уусмалд хийж 24 цагийн дотор Селл Клиник эмнэлэгт хүргэнэ.',
      //   'GMP лабораторид сүүн шүднээс үүдэл эсийг ялгаж чанарын хяналт хийснээр шингэн азотод хадгална.',
      //   'Үүдэл эсийн тоо, гарц болон чанарыг тодорхойлсон хадгалалтын гэрчилгээг эцэг эхчүүдэд өгнө.'
      // ],
      priceBox:
        'Төлбөрийг 6-12 сарын хугацаанд гуравдагч санхүүгийн байгууллагагүйгээр хуваан төлөөрэй.',
      price: 'Тун удахгүй'
    },
    isAvailable: true
  },
  {
    id: 7,
    name: 'GenomeCheck H',
    tag: 'Генетик шинжилгээ',
    price: '1980000',
    img: h,
    desc: 'Хавдрын эрсдэлийг тодорхойлох генетик шинжилгээ',
    content: {
      title: 'GenomeCheck H',
      photo: h1,
      desc: 'Бүх насныханд зориулагдсан GENOMECHECK H шинжилгээ нь 11 төрлийн хавдрын удамшлын эрсдэлийг тодорхойлох өндөр нарийвчлалтай генетиĸийн шинжилгээ юм. Энэхүү шинжилгээ нь уушги, ходоод, элэг, нойр булчирхай, хөх, бөөр, улаан хоолой, давсаг, цөсний хүүдий, бамбай булчирхай, бүдүүн шулуун гэдэсний хорт хавдрын эрсдэлийг үнэлнэ.  ',
      // benefits: [
      //   'Эрүүл амьдралын зөв хэв маягийг бүрдүүлэх',
      //   'Хавдар болон удамшлын өвчнийг эрт илрүүлж, хяналт тавих',
      //   'Хүүхдийн ирээдүйн эрүүл мэндийг хамгийн найдвартай байдлаар хамгаалах'
      // ],

      title3:
        'ЯАГААД ХАВДРЫН ЭРСДЭЛ ТОДОРХОЙЛОХ ГЕНЕТИК ШИНЖИЛГЭЭГ ХИЙЛГЭХ ЁСТОЙ ВЭ?',
      process: [
        {
          id: 1,
          title: 'Эрүүл мэндээ урьдчилан хамгаалах',
          desc: [
            'Хорт хавдрыг үүсэхээс өмнө эрсдэлийг эрт илрүүлэх нь урьдчилан сэргийлэх, амьдралын хэв маягаа өөрчлөх, өвчнийг хянах боломжийг олгодог.'
          ]
        },
        {
          id: 2,
          title: 'Санхүүгийн дарамтаас сэргийлэх',
          desc: [
            'Хавдрын эмчилгээний өндөр зардлаас урьдчилан сэргийлэхэд тусална.'
          ]
        },
        {
          id: 3,
          title: 'Гэр бүлийн сэтгэл зүй ба шинжлэх ухаанч шийдэл',
          desc: [
            'Эрсдэлийг эрүүл мэндийн шинжлэх ухааны үндэслэлтэйгээр урьдчилан мэдэх нь гэр бүлийн гишүүдийн сэтгэл зүйд тайван байдал авчирч, урт хугацааны эрүүл мэндийн төлөвлөгөө гаргах боломжийг бүрдүүлдэг. Энэ нь эрүүл мэндэд хандах хандлагыг илүү шинжлэх ухаанч, бодитой болгож, урьдчилан сэргийлэх арга хэмжээг цаг алдалгүй авах замаар гэр бүлийн амьдралын чанарыг дээшлүүлж, урт наслах боломжийг нэмэгдүүлдэг.'
          ]
        }
      ],
      text2: 'Шинжилгээг хэрхэн хийлгэх вэ?',
      treatments: [
        '1. Доор байрлах цаг захиалах товчлуурт дарж эсвэл 7776-0000 дугаарт залгаж цаг авна.',
        '2. Селл Клиниĸ эмнэлэгт ирж шинжилгээ өгнө.',
        '3. Шинжилгээг амны хөндийгөөс арчдас аван шинжилдэг учир зовиургүй',
        '4. Шинжилгээний хариу 14-21 хоногийн дотор гарна.',
        '5. Селл Клиниĸ эмнэлгээс шинжилгээний хариуг зөвхөн тухайн үйлчлүүлэгчид өөрт нь өгөх бөгөөд мэргэжлийн эмч шинжилгээний хариуг дэлгэрэнгүй тайлбарлан өгнө. Хариуг файл хэлбэрээр үйлчлүүлэгчийн анх бүртгүүлсэн и-мэйл хаягт илгээх ба 20-30 хуудас бүхий хэвлэмэл хувилбарыг баталгаат шуудангаар илгээх эсвэл эмнэлэг дээр өөрийн биеэр ирэн авна.'
      ],
      text4:
        'ТА ШИНЖИЛГЭЭ ӨГӨХӨӨР ИРЭХЭЭС 30 МИНУТЫН ӨМНӨ ТАМХИ ТАТААГҮЙ , ХООЛ, ХҮНС ИДЭЖ УУГААГҮЙ, АМАА УГААГААГҮЙ, УРУУЛАА БУДААГҮЙ БАЙХЫГ АНХААРНА УУ!',
      title4:
        'GenomeCheck H нь хавдраас урьдчилан сэргийлэх, хавдраар өвдөхгүй байх, урт удаан чанартай амьдралыг бий болгох боломжийг олгодог.',
      title5: ' Гэр бүл, байгууллагын хөнгөлөлт: 10-15%',
      price: 2500000,
      // priceList: [
      //   { name: '10 хромосомын гажиг: 1’200’00₮', price: 1200000 },
      //   { name: '123 хромосомын гажиг: 1’800’000₮', price: 1800000 },
      //   { name: '400 хромосомын гажиг: 2’500’000₮', price: 2500000 }
      // ]
      isBrochure: true,
      pdfUrl: 'https://cellclinic.mn/pdf/CellClinic_Genomecheck_H.pdf'
    },
    isAvailable: true
  },
  {
    id: 8,
    name: 'GenomeCheck M',
    tag: 'Генетик шинжилгээ',
    price: '1980000',
    img: m,
    desc: 'Төрөхөөс өмнөх генетикийн шинжилгээ (НИПТ)',
    isAvailable: true,
    content: {
      title: '3 ТӨРЛИЙН СОНГОЛТТОЙ',
      photo: m1,
      desc: 'GENOMECHECK M (НИПТ) буюу ургийн хромосомын эмгэг, хүйс тодорхойлох уг шинжилгээ нь жирэмсний эрт үед (10-24 долоо хоног) эхийн цуснаас ургийн чөлөөт ДНХ -г ялган авч хромосомын тооны болон бүтцийн өөрчлөлтийг оношлох өндөр нарийвчлалтай дэвшилтэт шинжилгээ юм. Энэ шинжилгээ нь Даун, Эдвардс, Патаугийн хам шинж зэрэг 10, 123, 424 хромосомын эмгэгийг тодорхойлохоос гадна ургийн ХҮЙСИЙГ тодорхойлдог.',
      title3: 'GenomeCheck M шинжилгээний давуу тал',
      process: [
        {
          id: 1,
          title: '3 төрлийн сонголттой',
          desc: [
            '10 хромосомын эмгэг',
            '123 хромосомын эмгэг',
            '424 хромосомын эмгэг'
          ]
        },
        {
          id: 2,
          title: 'ӨНДӨР НАРИЙВЧЛАЛТАЙ',
          desc: [
            'Хромосомын эмгэгийг 99.9% -ийн нарийвчлалтай тодорхойлно. (NGS technology)'
          ]
        },
        {
          id: 3,
          title: 'ЭРТ ОНОШИЛГОО',
          desc: ['Жирэмсний 10-24 долоо хоногт хийх боломжтой.']
        },
        {
          id: 4,
          title: 'ХУРДАН',
          desc: ['Шинжилгээний хариу 2 долоо хоногт гарна.']
        },
        {
          id: 5,
          title: 'ЭРСДЭЛГҮЙ',
          desc: [
            'Шинжилгээнд зөвхөн эхийн цусны дээж шаардлагатай тул ургийг гэмтээх эрсдэлгүй.'
          ]
        }
      ],
      text2: 'Шинжилгээ хэрхэн өгөх вэ?',
      treatments: [
        '1. Доор байрлах цаг захиалах товчлуурт дарж эсвэл 7776-0000 дугаарт залгаж цаг авна.',
        '2. Селл Клиниĸ эмнэлэгт ирж шинжилгээг өгнө.',
        '3. Шинжилгээг эхийн цуснаас дээж аван шинжилдэг учир урагт эрсдэлгүй.',
        '4. Шинжилгээний хариу 14 хоногийн дотор гарна.',
        '5. Селл Клиниĸ эмнэлгээс шинжилгээний хариуг зөвхөн тухайн үйлчлүүлэгчид өөрт нь өгөх бөгөөд мэргэжлийн эмч шинжилгээний хариуг дэлгэрэнгүй тайлбарлан өгнө. Хариуг файл хэлбэрээр үйлчлүүлэгчийн анх бүртгүүлсэн и-мэйл хаягт илгээх ба 20-30 хуудас бүхий хэвлэмэл хувилбарыг баталгаат шуудангаар илгээх эсвэл эмнэлэг дээр өөрийн биеэр ирэн авна.'
      ],
      genList: [
        {
          title: '10 хромосомын гажиг',
          main: 'Disease detection',
          aList: [
            'Down syndrome (Trisomy 21)',
            "Edwards' syndrome (Trisomy 18)",
            "Patau's syndrome (Trisomy 13)",
            'Trisomy 9',
            'Trisomy 16',
            'Trisomy 22',
            "Turner's syndrome",
            'Klinefelter syndrome',
            'Triple X syndrome',
            'Jacob syndrome'
          ],
          main1: 'Additional disease detection',
          bList: [
            'Monosomy 1p36',
            'Wolf-Hirschhorn Syndrome: 4p16',
            'Cri du Chat Syndrome: 5p15',
            'Langer-Giedion Syndrome: 8q24',
            'Jacobsen Syndrome: 11q23',
            'Prader-Willi Syndrome: 15q11',
            'Angelman Syndrome: 15q11',
            'DiGeorge Syndrome: 22q11'
          ],
          main2: 'Autosomal neuploidy',
          cList: [
            'Monosomy 1',
            'Trisomy 1',
            'Monosomy 2',
            'Trisomy 2',
            'Monosomy 3',
            'Trisomy 3',
            'Monosomy 4',
            'Trisomy 4',
            'Monosomy 5',
            'Trisomy 5',
            'Monosomy 6',
            'Trisomy 6',
            'Monosomy 7',
            'Trisomy 7',
            'Monosomy 8',
            'Trisomy 8',
            'Monosomy 9',
            'Monosomy 10',
            'Trisomy 10',
            'Monosomy 11',
            'Trisomy 11',
            'Monosomy 12',
            'Trisomy 12',
            'Monosomy 13',
            'Monosomy 14',
            'Trisomy 14',
            'Monosomy 15',
            'Trisomy 15',
            'Monosomy 16',
            'Monosomy 17',
            'Trisomy 17',
            'Monosomy 18',
            'Monosomy 19',
            'Trisomy 19',
            'Monosomy 20',
            'Trisomy 20',
            'Monosomy 21',
            'Monosomy 22'
          ],
          main3: 'Microduplication / Microdeletion disease detection',
          main4: 'Microduplication / Microdeletion disease detection',
          eList: [
            '1p31.3 del',
            '1p36.33-p36.31 del',
            '1p36.11 del',
            '1p36.12 del',
            '1p36.13 del',
            '1p36.21 del',
            '1p36.33 del',
            '1q21.1 del',
            '1q21.1-q21.2 del',
            '1q21.2 del',
            '1q21.3 del',
            '1q23.3 del',
            '1q24.2 del',
            '1q25.2 del',
            '1q32.2 del',
            '1q41 del',
            '1q43-q44 del',
            '1q44 del',
            '20p11.22 del',
            '20q11.21 del',
            '21q11.2 del',
            '21q22.3 del',
            '22q11.21 ',
            '22q11.21-q11.22',
            '22q11.22-q11.23',
            '22q11.21-q11.23',
            '22q11.22q11.23',
            '22q11.23',
            '22q11.1-q11.21',
            '22q11.22 del',
            '22q13.1 del',
            '2p11.2 del',
            '2p15-p16.1 del',
            '2p21 del',
            '2p24.3 del',
            '2q11.2 del',
            '2q13 del',
            '2q21.1 del',
            '2q21.2 del',
            '15q26.3 del',
            '16p11.1 del',
            '3p12.3 del',
            '3q11.2 del',
            '3q24 del',
            '3q25.31 del',
            '3q29 del',
            '4p11 del',
            '4p16.1 del ',
            '4p16.3 del ',
            '4q13.2 del',
            '4q13.3 del',
            '5p15.33-p15.2 del',
            '5p15.33 del',
            '5q13.2 del',
            '5q22.1 del',
            '5q31.3 del',
            '5q35.2-q35.3 del',
            '5q35.3 del',
            '6p21.32 del',
            '6p22.1 del',
            '6p25.3 del',
            '6q13 del',
            '6q24 del',
            '7p11.2 del',
            '7p14.1 del',
            '7p22.1 del',
            '7q11.21 del',
            '7q11.23 del',
            '7q22.1 del',
            '7q34 del',
            '7q35 del',
            '7q36.1 del',
            '7q36.3 del',
            '8p23.1 del',
            '8p23.3 del',
            '8q24.3 del',
            '9p11.1 del',
            '9p11.2 del',
            '9p12 del',
            '9p13.1 del',
            '9p24.3 del',
            '9q12 del',
            '9q13 del',
            '9q21.11 del',
            '9q31.1 del',
            '9q31.2 del',
            '9q32 del',
            '9q34.3 del',
            '14q32.2 del',
            '17q24.3 del',
            'Xp11.22 del',
            'Xp11.22-p11.23 del',
            'Xp11.23 del',
            'Xp21.2 del',
            'Xp22.31 del',
            'Xq21.1 del',
            'Xq24 del',
            'Xq25 del',
            'Xq26.3 del'
          ],
          dList: [
            '16p13.12 dup',
            '14q32.3 dup',
            '2q37.3 dup',
            '6p25 dup',
            '10p12.1 dup',
            '10p12.33 dup',
            '10p13 dup',
            '10q11.22-q11.23 dup',
            '10q11.22 dup',
            '10q11.23 dup',
            '10q22.1 dup',
            '10q22.3 dup',
            '10q22.3-q23.2 dup',
            '11p11.2 dup',
            '11p13 dup',
            '11p14.1 dup',
            '11p15.1 dup',
            '11p15.4 dup',
            '11p15.5 dup',
            '11q11 dup',
            '11q12.2 dup',
            '11q13.2-q13.4 dup',
            '11q13.4 dup',
            '11q14.3 dup',
            '11q22.2 dup',
            '11q23 dup',
            '12p11.1 dup',
            '21p11.2 dup',
            '12p11.23 dup',
            '12p13.2 dup',
            '12p13.31 dup',
            '12q12 dup',
            '12q23.3 dup',
            '13q12.11 dup',
            '13q12.12 dup',
            '13q21.1 dup',
            '13q21.33 dup',
            '14q11.2 dup',
            '14q13.2 dup',
            '14q32 dup',
            '14q32.33 dup',
            '15q11.2 dup',
            '15q11.2-q13.1 dup',
            '15q13.1-q13.2 dup',
            '15q13.2 dup',
            '15q13.3 dup',
            '15q13 dup',
            '15q14 dup',
            '15q24.1-q24.2 dup',
            '15q24 dup',
            '15q25.2 dup',
            '15q25.2-q25.3 dup',
            '16p11.2 dup',
            '16p12.1 dup',
            '16p12.2 dup',
            '16p12.3 dup',
            '16p13.11 dup',
            '16p13.3 dup',
            '16q22.1 dup',
            '16q22.2 dup',
            '16q23.1 dup',
            '17p11.2 dup',
            '17p12 dup',
            '17p13.3 dup',
            '17q11.2 dup',
            '17q12 dup',
            '17q21.2 dup',
            '17q21.3 dup',
            '17q21.31 dup',
            '17q23.1-q23.2 dup',
            '18p11.21 dup',
            '18p11.22 dup',
            '18p11.31 dup',
            '18q11.2 dup',
            '18q21.1 dup',
            '19p12 dup',
            '19p13.12 dup',
            '19p13.2 dup',
            '19q13.12 dup',
            '19q13 dup',
            '19q13.31 dup',
            '19q13.32 dup',
            '19q13.41 dup',
            '19q13.42 dup',
            '1p13.3 dup',
            '1p21.1 dup',
            '1p31.3 dup',
            '1p36.33-p36.31 dup',
            '1p36.11 dup',
            '1p36.12 dup',
            '1p36.13 dup',
            '1p36.21 dup',
            '1p36.33 dup',
            '1q21.1 dup',
            '1q21.1-q21.2 dup',
            '1q21.2 dup',
            '1q21.3 dup',
            '1q23.3 dup',
            '1q24.2 dup',
            '1q25.2 dup',
            '1q32.2 dup',
            '1q41 dup',
            '1q43-q44 dup',
            '1q44 dup',
            '20p11.22 dup',
            '20q11.21 dup',
            '21q11.2 dup',
            '21q22.3 dup',
            '22q11.21 dup',
            '22q11.21-q11.22 dup',
            '22q11.22-q11.23 dup',
            '22q11.21-q11.23 dup',
            '22q11.22q11.23 dup',
            '22q11.23 dup',
            '22q11.1-q11.21 dup',
            '22q11.22 dup',
            '22q13.1 dup',
            '2p11.2 dup',
            '2p15-p16.1 dup',
            '2p21 dup',
            '2p24.3 dup',
            '2q11.2 dup',
            '2q13 dup',
            '2q21.1 dup',
            '2q21.2 dup',
            '15q26.3 dup',
            '16p11.1 dup',
            '3p12.3 dup',
            '3q11.2 dup',
            '3q24 dup',
            '3q25.31 dup',
            '3q29 dup',
            '4p11 dup',
            '4p16.1 dup',
            '4p16.3 dup',
            '4q13.2 dup',
            '4q13.3 dup',
            '5p15.33-p15.2 dup',
            '5p15.33 dup',
            '5q13.2 dup',
            '5q22.1 dup',
            '5q31.3 dup',
            '5q35.2-q35.3 dup',
            '5q35.3 dup',
            '6p21.32 dup',
            '6p22.1 dup',
            '6p25.3 dup',
            '6q13 dup',
            '6q24 dup',
            '7p11.2 dup',
            '7p14.1 dup',
            '7p22.1 dup',
            '7q11.21 dup',
            '7q11.23 dup',
            '7q22.1 dup',
            '7q34 dup',
            '7q35 dup',
            '7q36.1 dup',
            '7q36.3 dup',
            '8p23.1 dup',
            '8p23.3 dup',
            '8q24.3 dup',
            '9p11.1 dup',
            '9p11.2 dup',
            '9p12 dup',
            '9p13.1 dup',
            '9p24.3 dup',
            '9q12 dup',
            '9q13 dup',
            '9q21.11 dup',
            '9q31.1 dup',
            '9q31.2 dup',
            '9q32 dup',
            '9q34.3 dup',
            '14q32.2 dup',
            '17q24.3 dup',
            'Xp11.22 dup',
            'Xp11.22-p11.23 dup',
            'Xp11.23 dup',
            'Xp21.2 dup',
            'Xp22.31 dup',
            'Xq21.1 dup',
            'Xq24 dup',
            'Xq25 dup',
            'Xq26.3 dup',
            'Xq27.3 dup',
            'Xq28 dup',
            'Yq11.223 dup',
            '16p13.12 del',
            '14q32.3 del',
            '2q37.3 del',
            '6p25 del',
            '10p12.1 del',
            '10p12.33 del',
            '10p13 del',
            '10q11.22-q11.23 del',
            '10q11.22 del',
            '10q11.23 del',
            '10q22.1 del',
            '10q22.3 del',
            '10q22.3-q23.2 del',
            '11p11.2 del',
            '11p13 del',
            '11p14.1 del',
            '11p15.1 del',
            '11p15.4 del',
            '11p15.5 del',
            '11q11 del',
            '11q12.2 del',
            '11q13.2-q13.4 del',
            '11q13.4 del',
            '11q14.3 del',
            '11q22.2 del',
            "11q23 del - 'Jacobsen Syndrome: 11q23'",
            '12p11.1 del',
            '21p11.2 del',
            '12p11.23 del',
            '12p13.2 del',
            '12p13.31 del',
            '12q12 del',
            '12q23.3 del',
            '13q12.11 del',
            '13q12.12 del',
            '13q21.1 del',
            '13q21.33 del',
            '14q11.2 del',
            '14q13.2 del',
            '14q32 del',
            '14q32.33 del',
            '15q11.2 del - Prader-Willi Syndrome: 15q11 - paternal',
            '15q11.2-q13.1 del - Angelman Syndrome: 15q11 - maternal',
            '15q13.1-q13.2 del',
            '15q13.2 del',
            '15q13.3 del',
            '15q13 del',
            '15q14 del',
            '15q24.1-q24.2 del',
            '15q24 del',
            '15q25.2 del',
            '15q25.2-q25.3 del',
            '16p11.2 del',
            '16p12.1 del',
            '16p12.2 del',
            '16p12.3 del',
            '16p13.11 del',
            '16p13.3 del',
            '16q22.1 del',
            '16q22.2 del',
            '16q23.1 del',
            '17p11.2 del',
            '17p12 del',
            '17p13.3 del',
            '17q11.2 del',
            '17q12 del',
            '17q21.2 del',
            '17q21.3 del',
            '17q21.31 del',
            '17q23.1-q23.2 del',
            '18p11.21 del',
            '18p11.22 del',
            '18p11.31 del',
            '18q11.2 del',
            '18q21.1 del',
            '19p12 del',
            '19p13.12 del',
            '19p13.2 del',
            '19q13.12 del',
            '19q13 del',
            '19q13.31 del',
            '19q13.32 del',
            '19q13.41 del',
            '19q13.42 del',
            '1p13.3 del',
            '1p21.1 del',
            '1p31.3 del',
            '1p36.33-p36.31 del - Monosomy 1p36',
            '1p36.11 del - Monosomy 1p36',
            '1p36.12 del - Monosomy 1p36',
            '1p36.13 del - Monosomy 1p36',
            '1p36.21 del - Monosomy 1p36',
            '1p36.33 del - Monosomy 1p36',
            '1q21.1 del',
            '1q21.1-q21.2 del',
            '1q21.2 del',
            '1q21.3 del',
            '1q23.3 del',
            '1q24.2 del',
            '1q25.2 del',
            '1q32.2 del',
            '1q41 del',
            '1q43-q44 del',
            '1q44 del',
            '20p11.22 del',
            '20q11.21 del',
            '21q11.2 del',
            '21q22.3 del',
            '22q11.21 delDiGeorge Syndrome: 22q11',
            '22q11.21-q11.22 delDiGeorge Syndrome: 22q11',
            '22q11.22-q11.23 delDiGeorge Syndrome: 22q11',
            '22q11.21-q11.23 delDiGeorge Syndrome: 22q11',
            '22q11.22q11.23 delDiGeorge Syndrome: 22q11',
            '22q11.23 delDiGeorge Syndrome: 22q11',
            '22q11.1-q11.21 delDiGeorge Syndrome: 22q11',
            '22q11.22 del',
            '22q13.1 del',
            '2p11.2 del',
            '2p15-p16.1 del',
            '2p21 del',
            '2p24.3 del',
            '2q11.2 del',
            '2q13 del',
            '2q21.1 del',
            '2q21.2 del',
            '15q26.3 del',
            '16p11.1 del',
            '3p12.3 del',
            '3q11.2 del',
            '3q24 del',
            '3q25.31 del',
            '3q29 del',
            '4p11 del',
            '4p16.1 del - Wolf-Hirschhorn Syndrome: 4p16',
            '4p16.3 del - Wolf-Hirschhorn Syndrome: 4p16',
            '4q13.2 del',
            '4q13.3 del',
            '5p15.33-p15.2 del - Cri du Chat Syndrome: 5p15',
            '5p15.33 del - Cri du Chat Syndrome: 5p15',
            '5q13.2 del',
            '5q22.1 del',
            '5q31.3 del',
            '5q35.2-q35.3 del',
            '5q35.3 del',
            '6p21.32 del',
            '6p22.1 del',
            '6p25.3 del',
            '6q13 del',
            '6q24 del',
            '7p11.2 del',
            '7p14.1 del',
            '7p22.1 del',
            '7q11.21 del',
            '7q11.23 del',
            '7q22.1 del',
            '7q34 del',
            '7q35 del',
            '7q36.1 del',
            '7q36.3 del',
            '8p23.1 del',
            '8p23.3 del',
            '8q24.3 del - Langer-Giedion Syndrome: 8q24',
            '9p11.1 del',
            '9p11.2 del',
            '9p12 del',
            '9p13.1 del',
            '9p24.3 del',
            '9q12 del',
            '9q13 del',
            '9q21.11 del',
            '9q31.1 del',
            '9q31.2 del',
            '9q32 del',
            '9q34.3 del',
            '14q32.2 del',
            '17q24.3 del',
            'Xp11.22 del',
            'Xp11.22-p11.23 del',
            'Xp11.23 del',
            'Xp21.2 del',
            'Xp22.31 del',
            'Xq21.1 del',
            'Xq24 del',
            'Xq25 del',
            'Xq26.3 del',
            'Xq27.3 del',
            'Xq28 del',
            'Yq11.223 del'
          ]
        }
      ],
      priceList: [
        { name: '10 хромосомын эмгэг', price: '1’500’000₮' },
        { name: '123 хромосомын эмгэг', price: '1’800’000₮' },
        { name: '424 хромосомын эмгэг', price: '2’500’000₮' }
      ],
      isBrochure: true,
      pdfUrl: 'https://cellclinic.mn/pdf/CellClinic_Genomecheck_MGPV.pdf'
      // price: 3000000
    }
  },
  {
    id: 9,
    name: 'GenomeCheck G',
    tag: 'Генетик шинжилгээ',
    price: '1980000',
    img: g,
    desc: 'Хромосомын тооны болон бүтцийн өөрчлөлтийн генетик шинжилгээ',
    content: {
      title: 'GenomeCheck G',
      photo: g1,
      desc: 'GENOMECHECK G нь шинжилгээ нь хүний хромосомын тоо, бүтцийг нарийвчлан судалж, удамшлын өвчин, төрөлхийн гажиг, үргүйдэл, зулбалт, хөгжлийн хоцрогдолтой холбоотой өөрчлөлтүүдийг илрүүлэхэд ашиглагддаг дэвшилтэт шинжилгээ юм. ',
      title3: 'Яагаад GenomeCheck G шинжилгээг хийлгэх ёстой вэ?',
      process: [
        {
          id: 1,
          title: 'ЭРТ ИЛРҮҮЛЭГ',
          desc: [
            'Удамшлын өвчин, хөгжлийн хоцрогдолтой холбоотой асуудлыг эрт илрүүлж, эмчилгээний арга хэмжээ авах боломжтой.'
          ]
        },
        {
          id: 2,
          title: 'СЭТГЭЛ ЗҮЙН ТАЙВАН БАЙДАЛ',
          desc: [
            'Хүүхдээ хромосомын өөрчлөлтгүй гэдгийг баталгаажуулснаар эцэг, эхийн сэтгэл зүй тайван байна.'
          ]
        },
        {
          id: 3,
          title: 'ОНОШИЛГООНЫ НАРИЙВЧЛАЛ',
          desc: [
            'Хромосомын томоохон өөрчлөлтөөс гадна жижиг гээгдэл, илүүдэл, зөөгдөлт зэрэг бүтцийн нарийн өөрчлөлтүүдийг илрүүлэх чадвартай.'
          ]
        },
        {
          id: 4,
          title: 'АУТИЗМЫН ХҮРЭЭНИЙ ЭМГЭГТЭЙ ХОЛБООТОЙ ӨӨРЧЛӨЛТИЙГ ИЛРҮҮЛЭХ',
          desc: [
            'Аутизмын хүрээний эмгэгтэй хүмүүсийн ойролцоогоор 10 орчим хувь нь хромосомын өөрчлөлттэй холбоотой байдаг. Энэхүү өөрчлөлтийг эрт илрүүлж, хүүхдийн хөгжлийн онцлогт тохирсон тусламж үзүүлэх боломж бүрдэнэ.'
          ]
        },
        {
          id: 5,
          title: 'ТӨЛӨВЛӨГӨӨ ГАРГАХ БОЛОМЖ',
          desc: [
            'Хромосомын эмгэг илэрсэн тохиолдолд эрүүл мэндийн урт хугацааны төлөвлөгөө гаргаж, хөгжлийн дэмжлэг, эмчилгээний арга хэмжээ авах боломжтой.'
          ]
        }
      ],
      text2: 'Шинжилгээг хэрхэн хийлгэх вэ?',
      treatments: [
        '1. Доор байрлах цаг захиалах товчлуурт дарж эсвэл 7776-0000 дугаарт залгаж цаг авна.',
        '2. Селл Клиниĸ эмнэлэгт ирж хүүхдийн амны салстаас арчдас өгнө.',
        '3. Шинжилгээний хариу 2-3 долоо хоногийн дотор гарна.',
        '4. Селл Клиниĸ эмнэлгээс шинжилгээний хариуг зөвхөн тухайн үйлчлүүлэгчид өөрт нь өгнө. Хариуг файл хэлбэрээр үйлчлүүлэгчийн анх бүртгүүлсэн и-мэйлд явуулах ба 20-30 хуудас бүхий хэвлэмэл хувилбарыг баталгаат шуудангаар илгээх эсвэл эмнэлэг дээр ирж авна.'
      ],
      text4:
        'ТА ШИНЖИЛГЭЭ ӨГӨХӨӨР ИРЭХЭЭС 30 МИНУТЫН ӨМНӨ ТАМХИ ТАТААГҮЙ , ХООЛ, ХҮНС ИДЭЖ УУГААГҮЙ, АМАА УГААГААГҮЙ, УРУУЛАА БУДААГҮЙ БАЙХЫГ АНХААРНА УУ!',
      price: 3000000,
      isBrochure: true,
      pdfUrl: 'https://cellclinic.mn/pdf/CellClinic_Genomecheck_MGPV.pdf'
    },
    isAvailable: true
  },
  {
    id: 10,
    name: 'GenomeCheck PV',
    tag: 'Генетик шинжилгээ',
    price: 1980000,
    img: pv,
    desc: 'Үр хөврөлийн хромосомын эмгэгийг илрүүлэх шинжилгээ',
    content: {
      title: 'GenomeCheck PV',
      photo: pv1,
      desc: 'GENOMECHECK PV (PGT) буюу үр хөврөл шилжүүлэн суулгахын өмнөх хромосомын өөрчлөлтийг илрүүлэх шинжилгээ нь лабораторийн орчинд үр тогтоолт хийн гарган авсан үр хөврөлийн хромосомын тооны болон бүтцийн өөрчлөлтийг судалж, эрүүл үр хөврөлийг эхийн умайд шилжүүлэн суулгах зорилготой дэвшилтэт арга юм. Энэ нь үргүйдэл, шалтгаан тодорхойгүй зулбалттай гэр бүлүүд, удамшлын өвчний эрсдэлтэй хосуудын хувьд чухал ач холбогдолтой. ',
      title3: 'Яагаад GenomeCheck PV шинжилгээг хийлгэх ёстой вэ?',
      process: [
        {
          id: 1,
          title: 'ЭРҮҮЛ ЖИРЭМСЛЭЛТИЙГ БАТАЛГААЖУУЛАХ',
          desc: [
            'Удамшлын өвчин, хромосомын эмгэгтэй үр хөврөл шилжүүлэн суулгахаас сэргийлдэг.'
          ]
        },
        {
          id: 2,
          title: 'ТӨРӨЛТИЙН ХУВИЙГ НЭМЭГДҮҮЛЭХ',
          desc: [
            'Хромосомын өөрчлөлтөөс үүдэлтэй зулбалтын эрсдэлийг бууруулна.'
          ]
        },
        {
          id: 3,
          title: 'УДАМШЛЫН ӨВЧНИЙ ҮРГЭЛЖЛЭЛИЙГ ЗОГСООХ',
          desc: [
            'Генетиĸийн өвчин үргэлжлэх магадлалтай хосуудад эрүүл хүүхэд төрүүлэх боломж олгоно.'
          ]
        },
        {
          id: 4,
          title: 'СЭТГЭЛ ЗҮЙН ТАЙВАН БАЙДАЛ',
          desc: [
            'Эцэг, эхэд ирээдүйд эрүүл хүүхэдтэй болох итгэлийг нэмэгдүүлдэг.'
          ]
        }
      ],

      price: 1500000,
      isBrochure: true,
      pdfUrl: 'https://cellclinic.mn/pdf/CellClinic_Genomecheck_MGPV.pdf'
    },
    isAvailable: true
  },
  {
    id: 11,
    name: 'ERP',
    tag: 'Эсийн эмчилгээ',
    price: 1200000,
    img: l1,
    desc: 'ERP - 150 тэрбум экзосом',
    content: {
      // title: 'ERP – Exosome Rich Plasma',
      photo: l11,
      title: 'ERP – Экзосомоор баялаг плазм',
      desc: 'Экзосомоор баялаг плазмын эмчилгээ нь орчин үеийн шинжлэх ухааны ололтод үндэслэн боловсруулсан, эд эсийн нөхөн төлжилтийг дэмжих хамгийн үр дүнтэй аргачлал юм. Энэхүү эмчилгээ нь аутологи буюу үйлчлүүлэгчийн өөрийн ялтас эсээс ялгарах экзосомыг баяжуулан буцаан өөрт нь хэрэглэдэг учраас гаж нөлөөгүй юм. ERP нь биеийн өөрийн нөхөн төлжих чадварыг дэмжиж, үрэвсэл болон насжилтын шинж тэмдгүүдийг бууруулахад тусална.',
      desc_1: 'НЭГ ТУНД: 120-150 ТЭРБУМ ЭКЗОСОМ',
      text: 'ERP - Яагаад шилдэг сонголт вэ? ',
      benefits: [
        'Илүү үр дүнтэй: Таны арьс, үс болон эд эсийг гүнзгий нөхөн сэргээнэ.',
        'Орчин үеийн шийдэл: Байгалийн нөхөн төлжих механизмыг дэмжсэн хамгийн дэвшилтэт технологи.',
        'Олон талын хэрэглээ: Гоо сайхан, эрүүл мэнд, нөхөн сэргээх эмчилгээнд өргөн ашиглагддаг.',
        'Гүнзгий нөхөн төлжүүлэлт: Экзосомууд нь эд эсийн хоорондын харилцан үйлчлэлийг идэвхжүүлж, арьс, үсний эдийг сэргээдэг.',
        'Насжилтын эсрэг үйлдэл: Арьсны уян хатан чанарыг нэмэгдүүлж, үрчлээ, толбо, унжилтыг бууруулна.',
        'Үрэвслийг бууруулна: Үрэвслийн эсрэг дохио дамжуулалтын молекулуудыг идэвхжүүлж, өвдөлт болон хаванг багасгана. Удаан хугацаанд үргэлжлэх нөлөөтэй.',
        'Эсийн нөхөн төлжилт: Гэмтсэн шөрмөс, мөгөөрсийг нөхөн сэргээж, өвдөлтийг багасгах үр дүнтэй.',
        'Аюулгүй байдал: Аутологи гаралтай тул гаж нөлөө багатай, аюулгүй.'
      ],
      highlight3: {
        main: 'ERP-ийн хэрэглээ',
        sub: [
          'Арьсны Нөхөн Сэргээх Эмчилгээ: Үрчлээ, нөсөө толбо, сорви, арьсны уян хатан чанарыг сайжруулна.',
          'Үсний Ургалт Дэмжих: Үс уналттай тэмцэж, үсний ургалтыг сайжруулна.',
          'Үе Мөчний Үрэвсэл (Артрит): Үе мөчний өвдөлт болон үрэвслийг бууруулж, хөдөлгөөнийг сайжруулна. Өвдөлт намдаах эмийн хэрэглээг бууруулна.',
          'Нөхөн Сэргээх Эмчилгээ: Шөрмөс, булчин, болон гэмтлийн дараах нөхөн төлжих үйл явцыг түргэсгэнэ.',
          'Гоо Сайхны Эмчилгээ: Арьсанд залуу, эрүүл, гэрэлтсэн төрхийг өгнө.'
        ]
      },
      highlight4: {
        main: 'Эмчилгээний үйл явц',
        sub: [
          'Үйлчлүүлэгчийн цусыг цуглуулж сийвэнг ялган ялтас эсээс ялгаргах экзосомыг баяжуулна.',
          'Экзосомоор баялаг плазмыг тарилга эсвэл микро тарилга ашиглан биед оруулна.',
          'Эмчилгээний үр дүн 2-4 долоо хоногийн дараа илэрч эхлэх бөгөөд удаан хугацааны туршид үргэлжилнэ.'
        ]
      },
      title4:
        'ERP нь PRP эмчилгээний дараагийн үеийн эмчилгээ бөгөөд 5-10 дахин үр дүнтэй.',
      price: 1200000,
      isBrochure: true,
      pdfUrl: 'https://cellclinic.mn/pdf/CellClinic_ERP.pdf'
    },
    isAvailable: true
  },
  {
    id: 12,
    name: 'SkinCell',
    tag: 'Эсийн эмчилгээ',
    price: 2800000,
    img: l3,
    desc: ' Арьс залуужуулах эсийн технологи',
    content: {
      title: 'SkinCell – Арьс залуужуулах эсийн технологи',
      photo: skincell,
      title1: 'SkinCell - Яагаад Шилдэг Сонголт Вэ? ',
      benefits: [
        'Арьсны амьд эс: Монголд одоогоор гоо сайхны зорилгоор амьд арьсны эсийг ашиглаж эхлээгүй байна. SkinCell нь үйлчлүүлэгчийн өөрийнх нь арьсны эсийг ашигладаг учир үр дүн өндөртэй, удаан үйлчилгээтэй.',
        'Арьсны уян хатан байдал: Сорвины бүтцийг хэвийн арьсны бүтцээр дахин шинэчилдэг төдийгүй уян хатан чанарыг нэмэгдүүлнэ. ',
        'Аюулгүй, найдвартай: Таны өөрийн арьсны эсийг ашигладаг тул гаж нөлөө бараг гарахгүй.'
      ],

      highlight5: {
        main: 'SkinCell - Хэрэглээ',
        sub: [
          'Арьсны хөгшрөл',
          'Батганы сорви ',
          'Гоо сайхны хэрэглээ',
          'Мэс заслын сорви',
          'Бага хэмжээний түлэгдэл'
        ]
      },
      desc: 'Арьсыг залуужуулж, батганы сорви арилгахад зориулсан SkinCell нь үйлчлүүлэгчийн өөрийнх нь эрүүл арьсны эдээс гарган авсан, GMP стандартыг хангасан эсийг лабораторид боловсруулж, тарихад бэлэн болгосон арьсны үүдэл эсээр баялаг холимог юм. Энэхүү бүтээгдэхүүн нь арьсны коллаген болон эластин ялгаралтыг идэвхжүүлж, арьсыг залуужуулахын зэрэгцээ уян хатан чанарыг нэмэгдүүлж, батганы сорвийг үр дүнтэй арилгах дэвшилтэт шийдэл болж байна. ',
      title3: 'Эмчилгээний Үйл Явц',
      process: [
        {
          id: 1,
          title: 'Биопси авах',
          desc: [
            'Чихний арын арьсны эрүүл хэсгээс (ихэвчлэн 2–4 мм) бага хэмжээтэй арьсны сорьц авна. Сорьц авсан хэсэг 3-4 хоногт бүрбэн эдгэнэ. Авсан сорьцод арьсны фибробласт, кератиноцит, меланоцит, арьсны үүдэл эс зэрэг эсүүд агуулагддаг.'
          ]
        },
        {
          id: 2,
          title: 'Эсийн ялгалт',
          desc: [
            'Сорьцыг тусгай лабораторийн нөхцөлд боловсруулж, эсийн холимгийг бэлтгэнэ.'
          ]
        },
        {
          id: 3,
          title: 'Эсийн холимгийг хэрэглэх',
          desc: [
            'Бэлтгэсэн эсийн холимгийг арьсанд тарилга эсвэл микро тарилгаар оруулна.'
          ]
        }
      ],
      title4: 'Арьсны амьд эс!',
      title4t:
        'Монголд одоогоор гоо сайхны зорилгоор арьсны амьд эсийг ашиглаж эхлээгүй байна. SkinCell нь үйлчлүүлэгчийн өөрийнх нь арьсны эсийг ашигладаг учир үр дүн өндөртэй, удаан үйлчилгээтэй.',
      price: 2500000,
      isBrochure: true,
      pdfUrl: 'https://cellclinic.mn/pdf/CellClinic_SkinCell.pdf'
    },
    isAvailable: true
  },
  {
    id: 14,
    name: 'HairCell',
    tag: 'Эсийн эмчилгээ',
    price: 1980000,
    img: l4,
    desc: 'Үс ургуулах эсийн технологи',
    content: {
      title: 'HairCell – Үс ургуулах эсийн технологи',
      photo: haircell,
      // title1: 'HairCell – Үс ургуулах эсийн технологи ',
      desc: 'Эрүүл хуйхнаас ялган авсан үсний булцууны үүдэл эсээр баяжуулсан эсийн холимог нь үсний булцуу шинээр үүсэн бүрэлдэхэд шаардлагатай бүхий л эсийг агуулсан нөхөн ургалтад төгс тохирох шийдэл юм. Энэхүү эмчилгээ нь халзарсан хэсгийн үсний булцууны тоог нэмэгдүүлж, шинээр үс ургах үйл явцыг идэвхжүүлнэ. ',
      desc1:
        'Хуйхны эсийн холимог эмчилгээ нь үйлчлүүлэгчийн өөрийн арьсны эсүүдийг ашиглан үс ургалтыг идэвхжүүлэх, үсний ширхгийг өтгөрүүлэх, хуйхны эрүүл мэндийг сайжруулах хамгийн дэвшилтэт аргуудын нэг юм.',
      text: 'HairCell - Яагаад шилдэг сонголт Вэ? ',
      benefits: [
        'Төрөлхийн үс ургалт: Үйлчлүүлэгчийн өөрийн эсүүдийг ашиглан үс ургалтыг дэмжих тул эрүүл, бат бөх үс ургана.',
        'Үрэвсэл, гэмтлийг багасгана: Хуйхыг сэргээн эрүүлжүүлж, үсний уутанцрын үйл ажиллагааг идэвхжүүлнэ.  ',
        'Аюулгүй, найдвартай: Үйлчлүүлэгчийн өөрийн арьсны эсийг ашигладаг тул гаж нөлөө бараг гарахгүй.'
      ],
      highlight3: {
        main: 'Хэн энэ эмчилгээг хийлгэх вэ?',
        sub: [
          'Үсний халзрал',
          'Үс шингэрэлт ',
          'Үс шилжүүлэн суулгах эмчилгээний дараа'
        ]
      },
      highlight4: {
        main: 'Үр дүн',
        sub: [
          'Эмчилгээ хийлгэснээс хойш 2-4 сарын дараа үсний ургалт нэмэгдэж эхэлнэ. Үсний ширхэг өтгөрч, чангарна, хуйхны нөхөн төлжилт идэвхэжнэ.'
        ]
      },
      title3: 'Эмчилгээний үйл явц',
      process: [
        {
          id: 1,
          title: 'Биопси авах',
          desc: [
            'Хуйхны эрүүл хэсгээс (ихэвчлэн 2–4 мм) бага хэмжээтэй арьсны сорьц авна. Сорьц авсан газар 3-4 хоногт бүрэн эдгэнэ. Авсан сорьц нь үс ургалтад шаардлагатай эсүүдийг (үсний булцууны үүдэл эс, арьсны эсүүд) агуулдаг.'
          ]
        },
        {
          id: 2,
          title: 'Эсийн ялгалт',
          desc: [
            'Сорьцыг тусгай лабораторийн нөхцөлд боловсруулж, эсийн холимгийг бэлтгэнэ.'
          ]
        },
        {
          id: 3,
          title: 'Эсийн холимгийг хэрэглэх',
          desc: [
            'Бэлтгэсэн хуйхны эсийн холимгийг хуйханд тарилга эсвэл микро тарилгаар оруулна.'
          ]
        },
        {
          id: 4,
          title: '',
          desc: [
            'Эсүүд хуйхны гэмтсэн хэсэгт үйлчилж, үсний уутанцрыг идэвхжүүлнэ.'
          ]
        }
      ],

      title4: 'Үсний булцууны амьд эс!',
      title4t:
        'Монголд одоогоор үс ургуулах зорилгоор үсний булцууны амьд эсийг ашиглаж эхлээгүй байна. HairCell нь үйлчлүүлэгчийн өөрийнх нь үсний булцууны эсийг ашигладаг учир үр дүн өндөртэй, удаан үйлчилгээтэй.',

      price: 2800000,
      isBrochure: true,
      pdfUrl: 'https://cellclinic.mn/pdf/CellClinic_HairCell.pdf'
    },
    isAvailable: true
  },
  {
    id: 14,
    name: 'SprayCell',
    tag: 'Эсийн эмчилгээ',
    price: 2500000,
    img: l2,
    desc: 'Түлэгдэлтийн эмчилгээний хувьсгал',
    content: {
      title: 'SprayCell - Түлэгдэлтийн эмчилгээний хувьсгал',
      photo: spraycell,
      // title1: 'Түлэгдэлтийн эмчилгээний хувьсгал',
      desc: 'Хүний өөрийнх нь арьсны эсийн холимгийг ашиглан түлэгдсэн арьсны нөхөн сэргэлтийг дэмжих дэвшилтэт технологийг санал болгож байна. Арьсны эсийн холимогт агуулагдах фибробласт, кератиноцит, меланоцит, арьсны үүдэл эс нь түлэгдсэн арьсны хэсгийн нөхөн төлжилтийг дэмжиж эдгэрэлтийн хугацааг багасгаж сорвижилтыг бууруулна. Уг эмчилгээг арьсны сорвижилт арилгах болон арьсны нөсөөжилт алдагдсан хэсгийг эмчлэхэд мөн хэрэглэж болно. ',
      text: 'Цацдаг арьсны эс - Яагаад Шилдэг Сонголт Вэ? ',
      benefits: [
        'Нэмж шарх үүсгэхгүй: Түлэгдэлтийн одоогийн эмчилгээ болох арьс шилжүүлэн суулгах үед түлэгдэлтийн талбайтай адил хэмжээтэй арьсыг авч шилжүүлэн суулгадаг. SprayCell эмчилгээ нь цацах талбайгаас 80 дахин бага арьсыг авч арьсны эсийг ялгах ба арьс шилжүүлэн суулгахтай ижил үр дүнтэй.',
        'Нотлогдсон технологи: Өндөр хөгжилтэй 33 оронд нэвтэрсэн. ',
        'Хурдан эдгэрэлт: SprayCell эмчилгээ нь түлэгдсэн хэсгийн нөхөн сэргэлтийг хурдасгаж, эдгэрэлтийн хугацааг богиносгоно.',
        'Сорвижилт бага: Цацсан арьсны эсүүд олон тооны эдгэрэлтийн голомтыг үүсгэж сорви үүсэх боломжийг багасгадаг. ',
        'Эдийн үр дүнтэй ашиглалт: Их талбайг хамарсан түлэгдэлтийн үед ашиглах шилдэг сонголт. ',
        'Аюулгүй байдал: Өөрийн арьсыг өөрт (аутологи) нь хэрэглэж байгаа тул гаж нөлөө багатай. GMP стандартын лабораторид ариутгал, чанарын өндөр хяналтаар боловсруулсан бүтээгдэхүүн.'
      ],
      after: {
        main: 'Эмчилгээний үйл явц',
        sub: [
          'Арьсны жижиг хэсгийг дерматомоор авч (60-80 хуваасны нэгтэй тэнцэх хэмжээтэй) GMP лабораторид боловсруулах.',
          'Бэлтгэсэн эсийн холимгийг эмнэлэгт хүргэж мэргэжлийн эмч нар эсийн холимгийг түлэгдсэн хэсэгт шүршиж хэрэглэнэ. ',
          'Шүршсэний дараах шаардлагатай арчилгааг хийж эдгэрэлтийг эхлүүлнэ.'
        ]
      },
      title4: 'Арьсны амьд эс!',
      title4t:
        'Энэхүү эмчилгээ нь дэлхийн өндөр хөгжилтэй 33 оронд нэвтэрсэн бөгөөд FDA 2023 онд хүлээн зөвшөөрсөн эмчилгээ юм.',
      price: "Тун удахгүй",
      // price: 2500000,
      isBrochure: true,
      pdfUrl: 'https://cellclinic.mn/pdf/CellClinic_SprayCell.pdf'
    },
    isAvailable: true
  }
]
